var map = {
	"./bg/300": 220,
	"./bg/300.jpg": 220,
	"./bg/350": 221,
	"./bg/350.jpg": 221,
	"./bg/400": 222,
	"./bg/400.jpg": 222,
	"./bg/450": 223,
	"./bg/450.jpg": 223,
	"./bg/bg-1": 224,
	"./bg/bg-1.jpg": 224,
	"./bg/bg-2": 225,
	"./bg/bg-2.jpg": 225,
	"./bg/bg-3": 226,
	"./bg/bg-3.jpg": 226,
	"./bg/bg-4": 227,
	"./bg/bg-4.jpg": 227,
	"./bg/bg-5": 228,
	"./bg/bg-5.jpg": 228,
	"./bg/bg-6": 189,
	"./bg/bg-6.jpg": 1353,
	"./bg/bg-6.png": 189,
	"./bg/bg-7": 229,
	"./bg/bg-7.jpg": 229,
	"./bg/bg-8": 230,
	"./bg/bg-8.jpg": 230,
	"./bg/bg-9": 231,
	"./bg/bg-9.jpg": 231,
	"./bg/demo4-bg-footer": 232,
	"./bg/demo4-bg-footer.jpg": 232,
	"./bg/home-2-bg": 233,
	"./bg/home-2-bg.svg": 233,
	"./bg/sc-home1-bg": 234,
	"./bg/sc-home1-bg.png": 234,
	"./blog/blog1": 235,
	"./blog/blog1.jpg": 235,
	"./blog/blog2": 236,
	"./blog/blog2.jpg": 236,
	"./blog/blog3": 237,
	"./blog/blog3.jpg": 237,
	"./blog/blog4": 238,
	"./blog/blog4.jpg": 238,
	"./blog/blog5": 239,
	"./blog/blog5.jpg": 239,
	"./client-logos/logo1": 240,
	"./client-logos/logo1.png": 240,
	"./client-logos/logo2": 241,
	"./client-logos/logo2.png": 241,
	"./client-logos/logo3": 242,
	"./client-logos/logo3.png": 242,
	"./client-logos/logo4": 243,
	"./client-logos/logo4.png": 243,
	"./client-logos/logo5": 244,
	"./client-logos/logo5.png": 244,
	"./company-logos/logo-1": 245,
	"./company-logos/logo-1.png": 245,
	"./company-logos/logo-2": 246,
	"./company-logos/logo-2.png": 246,
	"./company-logos/logo-3": 247,
	"./company-logos/logo-3.png": 247,
	"./company-logos/logo-4": 248,
	"./company-logos/logo-4.png": 248,
	"./company-logos/logo_client_color": 249,
	"./company-logos/logo_client_color.png": 249,
	"./company-logos/logo_client_white": 250,
	"./company-logos/logo_client_white.png": 250,
	"./company-logos/logo_invoice_dark": 251,
	"./company-logos/logo_invoice_dark.png": 251,
	"./company-logos/logo_invoice_white": 252,
	"./company-logos/logo_invoice_white.png": 252,
	"./demos/demo11/bg-1": 253,
	"./demos/demo11/bg-1.jpg": 253,
	"./demos/demo12/bg-1": 254,
	"./demos/demo12/bg-1.jpg": 254,
	"./demos/demo4/footer": 255,
	"./demos/demo4/footer.jpg": 255,
	"./demos/demo4/header": 256,
	"./demos/demo4/header.jpg": 256,
	"./demos/demo8/bg-1": 257,
	"./demos/demo8/bg-1.jpg": 257,
	"./demos/demo9/bg-300": 258,
	"./demos/demo9/bg-300.jpg": 258,
	"./demos/demo9/bg-350": 259,
	"./demos/demo9/bg-350.jpg": 259,
	"./demos/demo9/bg-400": 260,
	"./demos/demo9/bg-400.jpg": 260,
	"./demos/demo9/bg-450": 261,
	"./demos/demo9/bg-450.jpg": 261,
	"./demos/preview/demo1": 262,
	"./demos/preview/demo1.jpg": 262,
	"./demos/preview/demo10": 263,
	"./demos/preview/demo10.jpg": 263,
	"./demos/preview/demo11": 264,
	"./demos/preview/demo11.jpg": 264,
	"./demos/preview/demo12": 265,
	"./demos/preview/demo12.jpg": 265,
	"./demos/preview/demo13": 266,
	"./demos/preview/demo13.jpg": 266,
	"./demos/preview/demo14": 267,
	"./demos/preview/demo14.jpg": 267,
	"./demos/preview/demo15": 268,
	"./demos/preview/demo15.jpg": 268,
	"./demos/preview/demo16": 269,
	"./demos/preview/demo16.jpg": 269,
	"./demos/preview/demo17": 270,
	"./demos/preview/demo17.jpg": 270,
	"./demos/preview/demo18": 271,
	"./demos/preview/demo18.jpg": 271,
	"./demos/preview/demo19": 272,
	"./demos/preview/demo19.jpg": 272,
	"./demos/preview/demo2": 273,
	"./demos/preview/demo2.jpg": 273,
	"./demos/preview/demo20": 274,
	"./demos/preview/demo20.jpg": 274,
	"./demos/preview/demo21": 275,
	"./demos/preview/demo21.jpg": 275,
	"./demos/preview/demo22": 276,
	"./demos/preview/demo22.jpg": 276,
	"./demos/preview/demo3": 277,
	"./demos/preview/demo3.jpg": 277,
	"./demos/preview/demo4": 278,
	"./demos/preview/demo4.jpg": 278,
	"./demos/preview/demo5": 279,
	"./demos/preview/demo5.jpg": 279,
	"./demos/preview/demo6": 280,
	"./demos/preview/demo6.jpg": 280,
	"./demos/preview/demo7": 281,
	"./demos/preview/demo7.jpg": 281,
	"./demos/preview/demo8": 282,
	"./demos/preview/demo8.jpg": 282,
	"./demos/preview/demo9": 283,
	"./demos/preview/demo9.jpg": 283,
	"./envato/screen1": 284,
	"./envato/screen1.jpg": 284,
	"./envato/screen2": 285,
	"./envato/screen2.jpg": 285,
	"./error/bg1": 286,
	"./error/bg1.jpg": 286,
	"./error/bg2": 287,
	"./error/bg2.jpg": 287,
	"./error/bg3": 288,
	"./error/bg3.jpg": 288,
	"./error/bg4": 289,
	"./error/bg4.jpg": 289,
	"./error/bg5": 290,
	"./error/bg5.jpg": 290,
	"./error/bg6": 291,
	"./error/bg6.jpg": 291,
	"./files/css": 292,
	"./files/css.svg": 292,
	"./files/csv": 293,
	"./files/csv.svg": 293,
	"./files/doc": 294,
	"./files/doc.svg": 294,
	"./files/html": 295,
	"./files/html.svg": 295,
	"./files/javascript": 296,
	"./files/javascript.svg": 296,
	"./files/jpg": 297,
	"./files/jpg.svg": 297,
	"./files/mp4": 298,
	"./files/mp4.svg": 298,
	"./files/pdf": 299,
	"./files/pdf.svg": 299,
	"./files/xml": 300,
	"./files/xml.svg": 300,
	"./files/zip": 301,
	"./files/zip.svg": 301,
	"./flags/001-mauritius": 302,
	"./flags/001-mauritius.svg": 302,
	"./flags/003-austria": 303,
	"./flags/003-austria.svg": 303,
	"./flags/004-oman": 304,
	"./flags/004-oman.svg": 304,
	"./flags/005-ethiopia": 305,
	"./flags/005-ethiopia.svg": 305,
	"./flags/006-tanzania": 306,
	"./flags/006-tanzania.svg": 306,
	"./flags/007-nicaragua": 307,
	"./flags/007-nicaragua.svg": 307,
	"./flags/008-estonia": 308,
	"./flags/008-estonia.svg": 308,
	"./flags/009-uganda": 309,
	"./flags/009-uganda.svg": 309,
	"./flags/010-slovenia": 310,
	"./flags/010-slovenia.svg": 310,
	"./flags/011-zimbabwe": 311,
	"./flags/011-zimbabwe.svg": 311,
	"./flags/012-sao-tome-and-prince": 312,
	"./flags/012-sao-tome-and-prince.svg": 312,
	"./flags/013-italy": 313,
	"./flags/013-italy.svg": 313,
	"./flags/014-wales": 314,
	"./flags/014-wales.svg": 314,
	"./flags/015-el-salvador": 315,
	"./flags/015-el-salvador.svg": 315,
	"./flags/016-nepal": 316,
	"./flags/016-nepal.svg": 316,
	"./flags/017-christmas-island": 317,
	"./flags/017-christmas-island.svg": 317,
	"./flags/018-lebanon": 318,
	"./flags/018-lebanon.svg": 318,
	"./flags/019-ceuta": 319,
	"./flags/019-ceuta.svg": 319,
	"./flags/020-iraq": 320,
	"./flags/020-iraq.svg": 320,
	"./flags/021-cook-islands": 321,
	"./flags/021-cook-islands.svg": 321,
	"./flags/022-syria": 322,
	"./flags/022-syria.svg": 322,
	"./flags/023-cocos-island": 323,
	"./flags/023-cocos-island.svg": 323,
	"./flags/024-honduras": 324,
	"./flags/024-honduras.svg": 324,
	"./flags/025-anguilla": 325,
	"./flags/025-anguilla.svg": 325,
	"./flags/026-qatar": 326,
	"./flags/026-qatar.svg": 326,
	"./flags/027-american-samoa": 327,
	"./flags/027-american-samoa.svg": 327,
	"./flags/028-puerto-rico": 328,
	"./flags/028-puerto-rico.svg": 328,
	"./flags/029-comoros": 329,
	"./flags/029-comoros.svg": 329,
	"./flags/030-north-korea": 330,
	"./flags/030-north-korea.svg": 330,
	"./flags/031-corsica": 331,
	"./flags/031-corsica.svg": 331,
	"./flags/032-zambia": 332,
	"./flags/032-zambia.svg": 332,
	"./flags/033-saint-kitts-and-nevis": 333,
	"./flags/033-saint-kitts-and-nevis.svg": 333,
	"./flags/034-china": 334,
	"./flags/034-china.svg": 334,
	"./flags/035-luxembourg": 335,
	"./flags/035-luxembourg.svg": 335,
	"./flags/036-central-african-republic": 336,
	"./flags/036-central-african-republic.svg": 336,
	"./flags/037-jamaica": 337,
	"./flags/037-jamaica.svg": 337,
	"./flags/038-cape-verde": 338,
	"./flags/038-cape-verde.svg": 338,
	"./flags/039-monaco": 339,
	"./flags/039-monaco.svg": 339,
	"./flags/040-bhutan": 340,
	"./flags/040-bhutan.svg": 340,
	"./flags/041-paraguay": 341,
	"./flags/041-paraguay.svg": 341,
	"./flags/042-aruba": 342,
	"./flags/042-aruba.svg": 342,
	"./flags/043-montserrat": 343,
	"./flags/043-montserrat.svg": 343,
	"./flags/044-latvia": 344,
	"./flags/044-latvia.svg": 344,
	"./flags/045-andorra": 345,
	"./flags/045-andorra.svg": 345,
	"./flags/046-micronesia": 346,
	"./flags/046-micronesia.svg": 346,
	"./flags/047-dominican-republic": 347,
	"./flags/047-dominican-republic.svg": 347,
	"./flags/048-abkhazia": 348,
	"./flags/048-abkhazia.svg": 348,
	"./flags/049-tunisia": 349,
	"./flags/049-tunisia.svg": 349,
	"./flags/050-mauritania": 350,
	"./flags/050-mauritania.svg": 350,
	"./flags/051-cayman-islands": 351,
	"./flags/051-cayman-islands.svg": 351,
	"./flags/052-kosovo": 352,
	"./flags/052-kosovo.svg": 352,
	"./flags/053-ghana": 353,
	"./flags/053-ghana.svg": 353,
	"./flags/054-canary-islands": 354,
	"./flags/054-canary-islands.svg": 354,
	"./flags/055-scotland": 355,
	"./flags/055-scotland.svg": 355,
	"./flags/056-guinea-bissau": 356,
	"./flags/056-guinea-bissau.svg": 356,
	"./flags/057-burundi": 357,
	"./flags/057-burundi.svg": 357,
	"./flags/058-myanmar": 358,
	"./flags/058-myanmar.svg": 358,
	"./flags/059-gabon": 359,
	"./flags/059-gabon.svg": 359,
	"./flags/060-benin": 360,
	"./flags/060-benin.svg": 360,
	"./flags/061-saba-island": 361,
	"./flags/061-saba-island.svg": 361,
	"./flags/062-namibia": 362,
	"./flags/062-namibia.svg": 362,
	"./flags/063-japan": 363,
	"./flags/063-japan.svg": 363,
	"./flags/064-lithuania": 364,
	"./flags/064-lithuania.svg": 364,
	"./flags/065-eritrea": 365,
	"./flags/065-eritrea.svg": 365,
	"./flags/066-chad": 366,
	"./flags/066-chad.svg": 366,
	"./flags/067-kenya": 367,
	"./flags/067-kenya.svg": 367,
	"./flags/068-djibouti": 368,
	"./flags/068-djibouti.svg": 368,
	"./flags/069-british-indian-ocean-territory": 369,
	"./flags/069-british-indian-ocean-territory.svg": 369,
	"./flags/070-tuvalu-1": 370,
	"./flags/070-tuvalu-1.svg": 370,
	"./flags/071-serbia": 371,
	"./flags/071-serbia.svg": 371,
	"./flags/072-bonaire": 372,
	"./flags/072-bonaire.svg": 372,
	"./flags/073-togo": 373,
	"./flags/073-togo.svg": 373,
	"./flags/074-kazakhstan": 374,
	"./flags/074-kazakhstan.svg": 374,
	"./flags/075-antigua-and-barbuda": 375,
	"./flags/075-antigua-and-barbuda.svg": 375,
	"./flags/076-suriname": 376,
	"./flags/076-suriname.svg": 376,
	"./flags/077-jordan": 377,
	"./flags/077-jordan.svg": 377,
	"./flags/078-belize": 378,
	"./flags/078-belize.svg": 378,
	"./flags/079-st-barts": 379,
	"./flags/079-st-barts.svg": 379,
	"./flags/080-iceland": 380,
	"./flags/080-iceland.svg": 380,
	"./flags/081-bermuda": 381,
	"./flags/081-bermuda.svg": 381,
	"./flags/082-united-nations": 382,
	"./flags/082-united-nations.svg": 382,
	"./flags/083-somalia": 383,
	"./flags/083-somalia.svg": 383,
	"./flags/084-barbados": 384,
	"./flags/084-barbados.svg": 384,
	"./flags/085-solomon-islands": 385,
	"./flags/085-solomon-islands.svg": 385,
	"./flags/086-nigeria": 386,
	"./flags/086-nigeria.svg": 386,
	"./flags/087-aland-islands": 387,
	"./flags/087-aland-islands.svg": 387,
	"./flags/088-uruguay": 388,
	"./flags/088-uruguay.svg": 388,
	"./flags/089-sint-maarten": 389,
	"./flags/089-sint-maarten.svg": 389,
	"./flags/090-burkina-faso": 390,
	"./flags/090-burkina-faso.svg": 390,
	"./flags/091-slovakia": 391,
	"./flags/091-slovakia.svg": 391,
	"./flags/092-sierra-leone": 392,
	"./flags/092-sierra-leone.svg": 392,
	"./flags/093-basque-country": 393,
	"./flags/093-basque-country.svg": 393,
	"./flags/094-south-korea": 394,
	"./flags/094-south-korea.svg": 394,
	"./flags/095-pitcairn-islands": 395,
	"./flags/095-pitcairn-islands.svg": 395,
	"./flags/096-mozambique": 396,
	"./flags/096-mozambique.svg": 396,
	"./flags/097-san-marino": 397,
	"./flags/097-san-marino.svg": 397,
	"./flags/098-guatemala": 398,
	"./flags/098-guatemala.svg": 398,
	"./flags/099-albania": 399,
	"./flags/099-albania.svg": 399,
	"./flags/100-pakistan": 400,
	"./flags/100-pakistan.svg": 400,
	"./flags/101-northern-cyprus": 401,
	"./flags/101-northern-cyprus.svg": 401,
	"./flags/102-balearic-islands": 402,
	"./flags/102-balearic-islands.svg": 402,
	"./flags/103-marshall-island": 403,
	"./flags/103-marshall-island.svg": 403,
	"./flags/104-ecuador": 404,
	"./flags/104-ecuador.svg": 404,
	"./flags/105-cameroon": 405,
	"./flags/105-cameroon.svg": 405,
	"./flags/106-panama": 406,
	"./flags/106-panama.svg": 406,
	"./flags/107-kwait": 407,
	"./flags/107-kwait.svg": 407,
	"./flags/108-armenia": 408,
	"./flags/108-armenia.svg": 408,
	"./flags/109-romania": 409,
	"./flags/109-romania.svg": 409,
	"./flags/110-guinea": 410,
	"./flags/110-guinea.svg": 410,
	"./flags/111-afghanistan": 411,
	"./flags/111-afghanistan.svg": 411,
	"./flags/112-laos": 412,
	"./flags/112-laos.svg": 412,
	"./flags/113-greenland": 413,
	"./flags/113-greenland.svg": 413,
	"./flags/114-british-virgin-islands": 414,
	"./flags/114-british-virgin-islands.svg": 414,
	"./flags/115-hungary": 415,
	"./flags/115-hungary.svg": 415,
	"./flags/116-curacao": 416,
	"./flags/116-curacao.svg": 416,
	"./flags/117-angola": 417,
	"./flags/117-angola.svg": 417,
	"./flags/118-malasya": 418,
	"./flags/118-malasya.svg": 418,
	"./flags/119-brunei": 419,
	"./flags/119-brunei.svg": 419,
	"./flags/120-bahamas": 420,
	"./flags/120-bahamas.svg": 420,
	"./flags/121-new-zealand": 421,
	"./flags/121-new-zealand.svg": 421,
	"./flags/123-british-columbia": 422,
	"./flags/123-british-columbia.svg": 422,
	"./flags/124-vatican-city": 423,
	"./flags/124-vatican-city.svg": 423,
	"./flags/125-finland": 424,
	"./flags/125-finland.svg": 424,
	"./flags/126-botswana": 425,
	"./flags/126-botswana.svg": 425,
	"./flags/127-sri-lanka": 426,
	"./flags/127-sri-lanka.svg": 426,
	"./flags/128-spain": 427,
	"./flags/128-spain.svg": 427,
	"./flags/129-ossetia": 428,
	"./flags/129-ossetia.svg": 428,
	"./flags/130-sicily": 429,
	"./flags/130-sicily.svg": 429,
	"./flags/131-chile": 430,
	"./flags/131-chile.svg": 430,
	"./flags/132-bosnia-and-herzegovina": 431,
	"./flags/132-bosnia-and-herzegovina.svg": 431,
	"./flags/133-saudi-arabia": 432,
	"./flags/133-saudi-arabia.svg": 432,
	"./flags/134-liechtenstein": 433,
	"./flags/134-liechtenstein.svg": 433,
	"./flags/135-belarus": 434,
	"./flags/135-belarus.svg": 434,
	"./flags/136-iran": 435,
	"./flags/136-iran.svg": 435,
	"./flags/137-fiji": 436,
	"./flags/137-fiji.svg": 436,
	"./flags/138-bahrain": 437,
	"./flags/138-bahrain.svg": 437,
	"./flags/139-venezuela": 438,
	"./flags/139-venezuela.svg": 438,
	"./flags/140-east-timor": 439,
	"./flags/140-east-timor.svg": 439,
	"./flags/141-azerbaijan": 440,
	"./flags/141-azerbaijan.svg": 440,
	"./flags/142-tibet": 441,
	"./flags/142-tibet.svg": 441,
	"./flags/143-norway": 442,
	"./flags/143-norway.svg": 442,
	"./flags/144-algeria": 443,
	"./flags/144-algeria.svg": 443,
	"./flags/145-ukraine": 444,
	"./flags/145-ukraine.svg": 444,
	"./flags/146-gambia": 445,
	"./flags/146-gambia.svg": 445,
	"./flags/147-bangladesh": 446,
	"./flags/147-bangladesh.svg": 446,
	"./flags/148-madeira": 447,
	"./flags/148-madeira.svg": 447,
	"./flags/149-czech-republic": 448,
	"./flags/149-czech-republic.svg": 448,
	"./flags/150-bolivia": 449,
	"./flags/150-bolivia.svg": 449,
	"./flags/151-united-arab-emirates": 450,
	"./flags/151-united-arab-emirates.svg": 450,
	"./flags/152-kyrgyzstan": 451,
	"./flags/152-kyrgyzstan.svg": 451,
	"./flags/153-cuba": 452,
	"./flags/153-cuba.svg": 452,
	"./flags/154-swaziland": 453,
	"./flags/154-swaziland.svg": 453,
	"./flags/155-israel": 454,
	"./flags/155-israel.svg": 454,
	"./flags/156-costa-rica": 455,
	"./flags/156-costa-rica.svg": 455,
	"./flags/157-republic-of-the-congo": 456,
	"./flags/157-republic-of-the-congo.svg": 456,
	"./flags/158-egypt": 457,
	"./flags/158-egypt.svg": 457,
	"./flags/159-cambodia": 458,
	"./flags/159-cambodia.svg": 458,
	"./flags/160-northern-marianas-islands": 459,
	"./flags/160-northern-marianas-islands.svg": 459,
	"./flags/161-ivory-coast": 460,
	"./flags/161-ivory-coast.svg": 460,
	"./flags/162-germany": 461,
	"./flags/162-germany.svg": 461,
	"./flags/163-papua-new-guinea": 462,
	"./flags/163-papua-new-guinea.svg": 462,
	"./flags/164-croatia": 463,
	"./flags/164-croatia.svg": 463,
	"./flags/165-belgium": 464,
	"./flags/165-belgium.svg": 464,
	"./flags/166-morocco": 465,
	"./flags/166-morocco.svg": 465,
	"./flags/167-macao": 466,
	"./flags/167-macao.svg": 466,
	"./flags/168-bulgaria": 467,
	"./flags/168-bulgaria.svg": 467,
	"./flags/169-liberia": 468,
	"./flags/169-liberia.svg": 468,
	"./flags/170-greece": 469,
	"./flags/170-greece.svg": 469,
	"./flags/171-galapagos-islands": 470,
	"./flags/171-galapagos-islands.svg": 470,
	"./flags/172-st-lucia": 471,
	"./flags/172-st-lucia.svg": 471,
	"./flags/173-mali": 472,
	"./flags/173-mali.svg": 472,
	"./flags/174-denmark": 473,
	"./flags/174-denmark.svg": 473,
	"./flags/175-rapa-nui": 474,
	"./flags/175-rapa-nui.svg": 474,
	"./flags/176-lesotho": 475,
	"./flags/176-lesotho.svg": 475,
	"./flags/177-colombia": 476,
	"./flags/177-colombia.svg": 476,
	"./flags/178-palau": 477,
	"./flags/178-palau.svg": 477,
	"./flags/179-ireland": 478,
	"./flags/179-ireland.svg": 478,
	"./flags/180-french-polynesia": 479,
	"./flags/180-french-polynesia.svg": 479,
	"./flags/181-trinidad-and-tobago": 480,
	"./flags/181-trinidad-and-tobago.svg": 480,
	"./flags/182-niue": 481,
	"./flags/182-niue.svg": 481,
	"./flags/183-hong-kong": 482,
	"./flags/183-hong-kong.svg": 482,
	"./flags/184-sweden": 483,
	"./flags/184-sweden.svg": 483,
	"./flags/185-haiti": 484,
	"./flags/185-haiti.svg": 484,
	"./flags/186-dominica": 485,
	"./flags/186-dominica.svg": 485,
	"./flags/187-vanuatu": 486,
	"./flags/187-vanuatu.svg": 486,
	"./flags/188-peru": 487,
	"./flags/188-peru.svg": 487,
	"./flags/189-equatorial-guinea": 488,
	"./flags/189-equatorial-guinea.svg": 488,
	"./flags/190-uzbekistn": 489,
	"./flags/190-uzbekistn.svg": 489,
	"./flags/191-tonga": 490,
	"./flags/191-tonga.svg": 490,
	"./flags/192-philippines": 491,
	"./flags/192-philippines.svg": 491,
	"./flags/193-norfolk-island": 492,
	"./flags/193-norfolk-island.svg": 492,
	"./flags/194-malta": 493,
	"./flags/194-malta.svg": 493,
	"./flags/195-france": 494,
	"./flags/195-france.svg": 494,
	"./flags/196-tajikistan": 495,
	"./flags/196-tajikistan.svg": 495,
	"./flags/197-melilla": 496,
	"./flags/197-melilla.svg": 496,
	"./flags/198-argentina": 497,
	"./flags/198-argentina.svg": 497,
	"./flags/199-sudan": 498,
	"./flags/199-sudan.svg": 498,
	"./flags/200-south-africa": 499,
	"./flags/200-south-africa.svg": 499,
	"./flags/201-martinique": 500,
	"./flags/201-martinique.svg": 500,
	"./flags/202-taiwan": 501,
	"./flags/202-taiwan.svg": 501,
	"./flags/203-sahrawi-arab-democratic-republic": 502,
	"./flags/203-sahrawi-arab-democratic-republic.svg": 502,
	"./flags/204-guernsey": 503,
	"./flags/204-guernsey.svg": 503,
	"./flags/205-switzerland": 504,
	"./flags/205-switzerland.svg": 504,
	"./flags/206-rwanda": 505,
	"./flags/206-rwanda.svg": 505,
	"./flags/207-guam": 506,
	"./flags/207-guam.svg": 506,
	"./flags/208-palestine": 507,
	"./flags/208-palestine.svg": 507,
	"./flags/209-indonesia": 508,
	"./flags/209-indonesia.svg": 508,
	"./flags/210-grenada": 509,
	"./flags/210-grenada.svg": 509,
	"./flags/211-poland": 510,
	"./flags/211-poland.svg": 510,
	"./flags/212-moldova": 511,
	"./flags/212-moldova.svg": 511,
	"./flags/213-gibraltar": 512,
	"./flags/213-gibraltar.svg": 512,
	"./flags/214-malawi": 513,
	"./flags/214-malawi.svg": 513,
	"./flags/215-falkland-islands": 514,
	"./flags/215-falkland-islands.svg": 514,
	"./flags/216-england": 515,
	"./flags/216-england.svg": 515,
	"./flags/217-virgin-islands": 516,
	"./flags/217-virgin-islands.svg": 516,
	"./flags/218-turkey": 517,
	"./flags/218-turkey.svg": 517,
	"./flags/219-isle-of-man": 518,
	"./flags/219-isle-of-man.svg": 518,
	"./flags/220-vietnam": 519,
	"./flags/220-vietnam.svg": 519,
	"./flags/221-tuvalu": 520,
	"./flags/221-tuvalu.svg": 520,
	"./flags/222-niger": 521,
	"./flags/222-niger.svg": 521,
	"./flags/223-turks-and-caicos": 522,
	"./flags/223-turks-and-caicos.svg": 522,
	"./flags/224-portugal": 523,
	"./flags/224-portugal.svg": 523,
	"./flags/225-maldives": 524,
	"./flags/225-maldives.svg": 524,
	"./flags/226-united-states": 525,
	"./flags/226-united-states.svg": 525,
	"./flags/227-senegal": 526,
	"./flags/227-senegal.svg": 526,
	"./flags/228-nauru": 527,
	"./flags/228-nauru.svg": 527,
	"./flags/229-turkmenistan": 528,
	"./flags/229-turkmenistan.svg": 528,
	"./flags/230-singapore": 529,
	"./flags/230-singapore.svg": 529,
	"./flags/231-libya": 530,
	"./flags/231-libya.svg": 530,
	"./flags/232-yemen": 531,
	"./flags/232-yemen.svg": 531,
	"./flags/233-transnistria": 532,
	"./flags/233-transnistria.svg": 532,
	"./flags/234-australia": 533,
	"./flags/234-australia.svg": 533,
	"./flags/235-tokelau": 534,
	"./flags/235-tokelau.svg": 534,
	"./flags/236-republic-of-macedonia": 535,
	"./flags/236-republic-of-macedonia.svg": 535,
	"./flags/237-netherlands": 536,
	"./flags/237-netherlands.svg": 536,
	"./flags/238-thailand": 537,
	"./flags/238-thailand.svg": 537,
	"./flags/239-montenegro": 538,
	"./flags/239-montenegro.svg": 538,
	"./flags/240-azores-islands": 539,
	"./flags/240-azores-islands.svg": 539,
	"./flags/241-st-vincent-and-the-grenadines": 540,
	"./flags/241-st-vincent-and-the-grenadines.svg": 540,
	"./flags/242-madagascar": 541,
	"./flags/242-madagascar.svg": 541,
	"./flags/243-canada": 542,
	"./flags/243-canada.svg": 542,
	"./flags/244-south-sudan": 543,
	"./flags/244-south-sudan.svg": 543,
	"./flags/245-jersey": 544,
	"./flags/245-jersey.svg": 544,
	"./flags/246-india": 545,
	"./flags/246-india.svg": 545,
	"./flags/247-somaliland": 546,
	"./flags/247-somaliland.svg": 546,
	"./flags/248-russia": 547,
	"./flags/248-russia.svg": 547,
	"./flags/249-democratic-republic-of-congo": 548,
	"./flags/249-democratic-republic-of-congo.svg": 548,
	"./flags/250-sint-eustatius": 549,
	"./flags/250-sint-eustatius.svg": 549,
	"./flags/251-samoa": 550,
	"./flags/251-samoa.svg": 550,
	"./flags/252-mexico": 551,
	"./flags/252-mexico.svg": 551,
	"./flags/253-seychelles": 552,
	"./flags/253-seychelles.svg": 552,
	"./flags/254-nato": 553,
	"./flags/254-nato.svg": 553,
	"./flags/255-brazil": 554,
	"./flags/255-brazil.svg": 554,
	"./flags/256-georgia": 555,
	"./flags/256-georgia.svg": 555,
	"./flags/257-sardinia": 556,
	"./flags/257-sardinia.svg": 556,
	"./flags/258-mongolia": 557,
	"./flags/258-mongolia.svg": 557,
	"./flags/259-european-union": 558,
	"./flags/259-european-union.svg": 558,
	"./flags/260-united-kingdom": 559,
	"./flags/260-united-kingdom.svg": 559,
	"./flags/261-kiribati": 560,
	"./flags/261-kiribati.svg": 560,
	"./flags/262-hawaii": 561,
	"./flags/262-hawaii.svg": 561,
	"./icons/exchange": 562,
	"./icons/exchange.svg": 562,
	"./icons/logout": 563,
	"./icons/logout.svg": 563,
	"./icons/question": 564,
	"./icons/question.svg": 564,
	"./icons/svg/Clothes/Brassiere": 565,
	"./icons/svg/Clothes/Brassiere.svg": 565,
	"./icons/svg/Clothes/Briefcase": 566,
	"./icons/svg/Clothes/Briefcase.svg": 566,
	"./icons/svg/Clothes/Cap": 567,
	"./icons/svg/Clothes/Cap.svg": 567,
	"./icons/svg/Clothes/Crown": 568,
	"./icons/svg/Clothes/Crown.svg": 568,
	"./icons/svg/Clothes/Dress": 569,
	"./icons/svg/Clothes/Dress.svg": 569,
	"./icons/svg/Clothes/Hanger": 570,
	"./icons/svg/Clothes/Hanger.svg": 570,
	"./icons/svg/Clothes/Hat": 571,
	"./icons/svg/Clothes/Hat.svg": 571,
	"./icons/svg/Clothes/Panties": 572,
	"./icons/svg/Clothes/Panties.svg": 572,
	"./icons/svg/Clothes/Shirt": 573,
	"./icons/svg/Clothes/Shirt.svg": 573,
	"./icons/svg/Clothes/Shoes": 574,
	"./icons/svg/Clothes/Shoes.svg": 574,
	"./icons/svg/Clothes/Shorts": 575,
	"./icons/svg/Clothes/Shorts.svg": 575,
	"./icons/svg/Clothes/Sneakers": 576,
	"./icons/svg/Clothes/Sneakers.svg": 576,
	"./icons/svg/Clothes/Socks": 577,
	"./icons/svg/Clothes/Socks.svg": 577,
	"./icons/svg/Clothes/Sun-glasses": 578,
	"./icons/svg/Clothes/Sun-glasses.svg": 578,
	"./icons/svg/Clothes/T-Shirt": 579,
	"./icons/svg/Clothes/T-Shirt.svg": 579,
	"./icons/svg/Clothes/Tie": 580,
	"./icons/svg/Clothes/Tie.svg": 580,
	"./icons/svg/Code/Backspace": 581,
	"./icons/svg/Code/Backspace.svg": 581,
	"./icons/svg/Code/CMD": 582,
	"./icons/svg/Code/CMD.svg": 582,
	"./icons/svg/Code/Code": 583,
	"./icons/svg/Code/Code.svg": 583,
	"./icons/svg/Code/Commit": 584,
	"./icons/svg/Code/Commit.svg": 584,
	"./icons/svg/Code/Compiling": 585,
	"./icons/svg/Code/Compiling.svg": 585,
	"./icons/svg/Code/Control": 586,
	"./icons/svg/Code/Control.svg": 586,
	"./icons/svg/Code/Done-circle": 587,
	"./icons/svg/Code/Done-circle.svg": 587,
	"./icons/svg/Code/Error-circle": 588,
	"./icons/svg/Code/Error-circle.svg": 588,
	"./icons/svg/Code/Git1": 589,
	"./icons/svg/Code/Git1.svg": 589,
	"./icons/svg/Code/Git2": 590,
	"./icons/svg/Code/Git2.svg": 590,
	"./icons/svg/Code/Git3": 591,
	"./icons/svg/Code/Git3.svg": 591,
	"./icons/svg/Code/Git4": 592,
	"./icons/svg/Code/Git4.svg": 592,
	"./icons/svg/Code/Github": 593,
	"./icons/svg/Code/Github.svg": 593,
	"./icons/svg/Code/Info-circle": 594,
	"./icons/svg/Code/Info-circle.svg": 594,
	"./icons/svg/Code/Left-circle": 595,
	"./icons/svg/Code/Left-circle.svg": 595,
	"./icons/svg/Code/Loading": 596,
	"./icons/svg/Code/Loading.svg": 596,
	"./icons/svg/Code/Lock-circle": 597,
	"./icons/svg/Code/Lock-circle.svg": 597,
	"./icons/svg/Code/Lock-overturning": 598,
	"./icons/svg/Code/Lock-overturning.svg": 598,
	"./icons/svg/Code/Minus": 599,
	"./icons/svg/Code/Minus.svg": 599,
	"./icons/svg/Code/Option": 600,
	"./icons/svg/Code/Option.svg": 600,
	"./icons/svg/Code/Plus": 601,
	"./icons/svg/Code/Plus.svg": 601,
	"./icons/svg/Code/Puzzle": 602,
	"./icons/svg/Code/Puzzle.svg": 602,
	"./icons/svg/Code/Question-circle": 603,
	"./icons/svg/Code/Question-circle.svg": 603,
	"./icons/svg/Code/Right-circle": 604,
	"./icons/svg/Code/Right-circle.svg": 604,
	"./icons/svg/Code/Settings4": 605,
	"./icons/svg/Code/Settings4.svg": 605,
	"./icons/svg/Code/Shift": 606,
	"./icons/svg/Code/Shift.svg": 606,
	"./icons/svg/Code/Spy": 607,
	"./icons/svg/Code/Spy.svg": 607,
	"./icons/svg/Code/Stop": 608,
	"./icons/svg/Code/Stop.svg": 608,
	"./icons/svg/Code/Terminal": 609,
	"./icons/svg/Code/Terminal.svg": 609,
	"./icons/svg/Code/Thunder-circle": 610,
	"./icons/svg/Code/Thunder-circle.svg": 610,
	"./icons/svg/Code/Time-schedule": 611,
	"./icons/svg/Code/Time-schedule.svg": 611,
	"./icons/svg/Code/Warning-1-circle": 612,
	"./icons/svg/Code/Warning-1-circle.svg": 612,
	"./icons/svg/Code/Warning-2": 613,
	"./icons/svg/Code/Warning-2.svg": 613,
	"./icons/svg/Communication/Active-call": 614,
	"./icons/svg/Communication/Active-call.svg": 614,
	"./icons/svg/Communication/Add-user": 615,
	"./icons/svg/Communication/Add-user.svg": 615,
	"./icons/svg/Communication/Address-card": 616,
	"./icons/svg/Communication/Address-card.svg": 616,
	"./icons/svg/Communication/Adress-book1": 617,
	"./icons/svg/Communication/Adress-book1.svg": 617,
	"./icons/svg/Communication/Adress-book2": 618,
	"./icons/svg/Communication/Adress-book2.svg": 618,
	"./icons/svg/Communication/Archive": 619,
	"./icons/svg/Communication/Archive.svg": 619,
	"./icons/svg/Communication/Call": 620,
	"./icons/svg/Communication/Call#1": 621,
	"./icons/svg/Communication/Call#1.svg": 621,
	"./icons/svg/Communication/Call.svg": 620,
	"./icons/svg/Communication/Chat-check": 622,
	"./icons/svg/Communication/Chat-check.svg": 622,
	"./icons/svg/Communication/Chat-error": 623,
	"./icons/svg/Communication/Chat-error.svg": 623,
	"./icons/svg/Communication/Chat-locked": 624,
	"./icons/svg/Communication/Chat-locked.svg": 624,
	"./icons/svg/Communication/Chat-smile": 625,
	"./icons/svg/Communication/Chat-smile.svg": 625,
	"./icons/svg/Communication/Chat1": 626,
	"./icons/svg/Communication/Chat1.svg": 626,
	"./icons/svg/Communication/Chat2": 627,
	"./icons/svg/Communication/Chat2.svg": 627,
	"./icons/svg/Communication/Chat4": 628,
	"./icons/svg/Communication/Chat4.svg": 628,
	"./icons/svg/Communication/Chat5": 629,
	"./icons/svg/Communication/Chat5.svg": 629,
	"./icons/svg/Communication/Chat6": 630,
	"./icons/svg/Communication/Chat6.svg": 630,
	"./icons/svg/Communication/Clipboard-check": 631,
	"./icons/svg/Communication/Clipboard-check.svg": 631,
	"./icons/svg/Communication/Clipboard-list": 632,
	"./icons/svg/Communication/Clipboard-list.svg": 632,
	"./icons/svg/Communication/Contact1": 633,
	"./icons/svg/Communication/Contact1.svg": 633,
	"./icons/svg/Communication/Delete-user": 634,
	"./icons/svg/Communication/Delete-user.svg": 634,
	"./icons/svg/Communication/Dial-numbers": 635,
	"./icons/svg/Communication/Dial-numbers.svg": 635,
	"./icons/svg/Communication/Flag": 636,
	"./icons/svg/Communication/Flag.svg": 636,
	"./icons/svg/Communication/Forward": 637,
	"./icons/svg/Communication/Forward.svg": 637,
	"./icons/svg/Communication/Group": 638,
	"./icons/svg/Communication/Group-chat": 639,
	"./icons/svg/Communication/Group-chat.svg": 639,
	"./icons/svg/Communication/Group.svg": 638,
	"./icons/svg/Communication/Incoming-box": 640,
	"./icons/svg/Communication/Incoming-box.svg": 640,
	"./icons/svg/Communication/Incoming-call": 641,
	"./icons/svg/Communication/Incoming-call.svg": 641,
	"./icons/svg/Communication/Incoming-mail": 642,
	"./icons/svg/Communication/Incoming-mail.svg": 642,
	"./icons/svg/Communication/Mail": 643,
	"./icons/svg/Communication/Mail-at": 644,
	"./icons/svg/Communication/Mail-at.svg": 644,
	"./icons/svg/Communication/Mail-attachment": 645,
	"./icons/svg/Communication/Mail-attachment.svg": 645,
	"./icons/svg/Communication/Mail-box": 646,
	"./icons/svg/Communication/Mail-box.svg": 646,
	"./icons/svg/Communication/Mail-error": 647,
	"./icons/svg/Communication/Mail-error.svg": 647,
	"./icons/svg/Communication/Mail-heart": 648,
	"./icons/svg/Communication/Mail-heart.svg": 648,
	"./icons/svg/Communication/Mail-locked": 649,
	"./icons/svg/Communication/Mail-locked.svg": 649,
	"./icons/svg/Communication/Mail-notification": 650,
	"./icons/svg/Communication/Mail-notification.svg": 650,
	"./icons/svg/Communication/Mail-opened": 651,
	"./icons/svg/Communication/Mail-opened.svg": 651,
	"./icons/svg/Communication/Mail-unocked": 652,
	"./icons/svg/Communication/Mail-unocked.svg": 652,
	"./icons/svg/Communication/Mail.svg": 643,
	"./icons/svg/Communication/Missed-call": 653,
	"./icons/svg/Communication/Missed-call.svg": 653,
	"./icons/svg/Communication/Outgoing-box": 654,
	"./icons/svg/Communication/Outgoing-box.svg": 654,
	"./icons/svg/Communication/Outgoing-call": 655,
	"./icons/svg/Communication/Outgoing-call.svg": 655,
	"./icons/svg/Communication/Outgoing-mail": 656,
	"./icons/svg/Communication/Outgoing-mail.svg": 656,
	"./icons/svg/Communication/RSS": 657,
	"./icons/svg/Communication/RSS.svg": 657,
	"./icons/svg/Communication/Readed-mail": 658,
	"./icons/svg/Communication/Readed-mail.svg": 658,
	"./icons/svg/Communication/Reply": 659,
	"./icons/svg/Communication/Reply-all": 660,
	"./icons/svg/Communication/Reply-all.svg": 660,
	"./icons/svg/Communication/Reply.svg": 659,
	"./icons/svg/Communication/Right": 661,
	"./icons/svg/Communication/Right.svg": 661,
	"./icons/svg/Communication/Safe-chat": 662,
	"./icons/svg/Communication/Safe-chat.svg": 662,
	"./icons/svg/Communication/Send": 663,
	"./icons/svg/Communication/Send.svg": 663,
	"./icons/svg/Communication/Sending": 664,
	"./icons/svg/Communication/Sending mail": 665,
	"./icons/svg/Communication/Sending mail.svg": 665,
	"./icons/svg/Communication/Sending.svg": 664,
	"./icons/svg/Communication/Share": 666,
	"./icons/svg/Communication/Share.svg": 666,
	"./icons/svg/Communication/Shield-thunder": 667,
	"./icons/svg/Communication/Shield-thunder.svg": 667,
	"./icons/svg/Communication/Shield-user": 668,
	"./icons/svg/Communication/Shield-user.svg": 668,
	"./icons/svg/Communication/Snoozed-mail": 669,
	"./icons/svg/Communication/Snoozed-mail.svg": 669,
	"./icons/svg/Communication/Spam": 670,
	"./icons/svg/Communication/Spam.svg": 670,
	"./icons/svg/Communication/Thumbtack": 671,
	"./icons/svg/Communication/Thumbtack.svg": 671,
	"./icons/svg/Communication/Urgent-mail": 672,
	"./icons/svg/Communication/Urgent-mail.svg": 672,
	"./icons/svg/Communication/Write": 673,
	"./icons/svg/Communication/Write.svg": 673,
	"./icons/svg/Cooking/Baking-glove": 674,
	"./icons/svg/Cooking/Baking-glove.svg": 674,
	"./icons/svg/Cooking/Bowl": 675,
	"./icons/svg/Cooking/Bowl.svg": 675,
	"./icons/svg/Cooking/Chef": 676,
	"./icons/svg/Cooking/Chef.svg": 676,
	"./icons/svg/Cooking/Cooking-book": 677,
	"./icons/svg/Cooking/Cooking-book.svg": 677,
	"./icons/svg/Cooking/Cooking-pot": 678,
	"./icons/svg/Cooking/Cooking-pot.svg": 678,
	"./icons/svg/Cooking/Cutting board": 679,
	"./icons/svg/Cooking/Cutting board.svg": 679,
	"./icons/svg/Cooking/Dinner": 680,
	"./icons/svg/Cooking/Dinner.svg": 680,
	"./icons/svg/Cooking/Dish": 681,
	"./icons/svg/Cooking/Dish.svg": 681,
	"./icons/svg/Cooking/Dishes": 682,
	"./icons/svg/Cooking/Dishes.svg": 682,
	"./icons/svg/Cooking/Fork": 683,
	"./icons/svg/Cooking/Fork-spoon": 684,
	"./icons/svg/Cooking/Fork-spoon-knife": 685,
	"./icons/svg/Cooking/Fork-spoon-knife.svg": 685,
	"./icons/svg/Cooking/Fork-spoon.svg": 684,
	"./icons/svg/Cooking/Fork.svg": 683,
	"./icons/svg/Cooking/Frying-pan": 686,
	"./icons/svg/Cooking/Frying-pan.svg": 686,
	"./icons/svg/Cooking/Grater": 687,
	"./icons/svg/Cooking/Grater.svg": 687,
	"./icons/svg/Cooking/Kitchen-scale": 688,
	"./icons/svg/Cooking/Kitchen-scale.svg": 688,
	"./icons/svg/Cooking/Knife1": 689,
	"./icons/svg/Cooking/Knife1.svg": 689,
	"./icons/svg/Cooking/Knife2": 690,
	"./icons/svg/Cooking/Knife2.svg": 690,
	"./icons/svg/Cooking/KnifeAndFork1": 691,
	"./icons/svg/Cooking/KnifeAndFork1.svg": 691,
	"./icons/svg/Cooking/KnifeAndFork2": 692,
	"./icons/svg/Cooking/KnifeAndFork2.svg": 692,
	"./icons/svg/Cooking/Ladle": 693,
	"./icons/svg/Cooking/Ladle.svg": 693,
	"./icons/svg/Cooking/Rolling-pin": 694,
	"./icons/svg/Cooking/Rolling-pin.svg": 694,
	"./icons/svg/Cooking/Saucepan": 695,
	"./icons/svg/Cooking/Saucepan.svg": 695,
	"./icons/svg/Cooking/Shovel": 696,
	"./icons/svg/Cooking/Shovel.svg": 696,
	"./icons/svg/Cooking/Sieve": 697,
	"./icons/svg/Cooking/Sieve.svg": 697,
	"./icons/svg/Cooking/Spoon": 698,
	"./icons/svg/Cooking/Spoon.svg": 698,
	"./icons/svg/Design/Adjust": 699,
	"./icons/svg/Design/Adjust.svg": 699,
	"./icons/svg/Design/Anchor-center": 700,
	"./icons/svg/Design/Anchor-center-down": 701,
	"./icons/svg/Design/Anchor-center-down.svg": 701,
	"./icons/svg/Design/Anchor-center-up": 702,
	"./icons/svg/Design/Anchor-center-up.svg": 702,
	"./icons/svg/Design/Anchor-center.svg": 700,
	"./icons/svg/Design/Anchor-left": 703,
	"./icons/svg/Design/Anchor-left-down": 704,
	"./icons/svg/Design/Anchor-left-down.svg": 704,
	"./icons/svg/Design/Anchor-left-up": 705,
	"./icons/svg/Design/Anchor-left-up.svg": 705,
	"./icons/svg/Design/Anchor-left.svg": 703,
	"./icons/svg/Design/Anchor-right": 706,
	"./icons/svg/Design/Anchor-right-down": 707,
	"./icons/svg/Design/Anchor-right-down.svg": 707,
	"./icons/svg/Design/Anchor-right-up": 708,
	"./icons/svg/Design/Anchor-right-up.svg": 708,
	"./icons/svg/Design/Anchor-right.svg": 706,
	"./icons/svg/Design/Arrows": 709,
	"./icons/svg/Design/Arrows.svg": 709,
	"./icons/svg/Design/Bezier-curve": 710,
	"./icons/svg/Design/Bezier-curve.svg": 710,
	"./icons/svg/Design/Border": 711,
	"./icons/svg/Design/Border.svg": 711,
	"./icons/svg/Design/Brush": 712,
	"./icons/svg/Design/Brush.svg": 712,
	"./icons/svg/Design/Bucket": 713,
	"./icons/svg/Design/Bucket.svg": 713,
	"./icons/svg/Design/Cap-1": 714,
	"./icons/svg/Design/Cap-1.svg": 714,
	"./icons/svg/Design/Cap-2": 715,
	"./icons/svg/Design/Cap-2.svg": 715,
	"./icons/svg/Design/Cap-3": 716,
	"./icons/svg/Design/Cap-3.svg": 716,
	"./icons/svg/Design/Circle": 717,
	"./icons/svg/Design/Circle.svg": 717,
	"./icons/svg/Design/Color": 718,
	"./icons/svg/Design/Color-profile": 719,
	"./icons/svg/Design/Color-profile.svg": 719,
	"./icons/svg/Design/Color.svg": 718,
	"./icons/svg/Design/Component": 720,
	"./icons/svg/Design/Component.svg": 720,
	"./icons/svg/Design/Crop": 721,
	"./icons/svg/Design/Crop.svg": 721,
	"./icons/svg/Design/Difference": 722,
	"./icons/svg/Design/Difference.svg": 722,
	"./icons/svg/Design/Edit": 723,
	"./icons/svg/Design/Edit.svg": 723,
	"./icons/svg/Design/Eraser": 724,
	"./icons/svg/Design/Eraser.svg": 724,
	"./icons/svg/Design/Flatten": 725,
	"./icons/svg/Design/Flatten.svg": 725,
	"./icons/svg/Design/Flip-horizontal": 726,
	"./icons/svg/Design/Flip-horizontal.svg": 726,
	"./icons/svg/Design/Flip-vertical": 727,
	"./icons/svg/Design/Flip-vertical.svg": 727,
	"./icons/svg/Design/Horizontal": 728,
	"./icons/svg/Design/Horizontal.svg": 728,
	"./icons/svg/Design/Image": 729,
	"./icons/svg/Design/Image.svg": 729,
	"./icons/svg/Design/Interselect": 730,
	"./icons/svg/Design/Interselect.svg": 730,
	"./icons/svg/Design/Join-1": 731,
	"./icons/svg/Design/Join-1.svg": 731,
	"./icons/svg/Design/Join-2": 732,
	"./icons/svg/Design/Join-2.svg": 732,
	"./icons/svg/Design/Join-3": 733,
	"./icons/svg/Design/Join-3.svg": 733,
	"./icons/svg/Design/Layers": 734,
	"./icons/svg/Design/Layers.svg": 734,
	"./icons/svg/Design/Line": 735,
	"./icons/svg/Design/Line.svg": 735,
	"./icons/svg/Design/Magic": 736,
	"./icons/svg/Design/Magic.svg": 736,
	"./icons/svg/Design/Mask": 737,
	"./icons/svg/Design/Mask.svg": 737,
	"./icons/svg/Design/Patch": 738,
	"./icons/svg/Design/Patch.svg": 738,
	"./icons/svg/Design/Pen-tool-vector": 739,
	"./icons/svg/Design/Pen-tool-vector.svg": 739,
	"./icons/svg/Design/PenAndRuller": 740,
	"./icons/svg/Design/PenAndRuller.svg": 740,
	"./icons/svg/Design/Pencil": 741,
	"./icons/svg/Design/Pencil.svg": 741,
	"./icons/svg/Design/Picker": 742,
	"./icons/svg/Design/Picker.svg": 742,
	"./icons/svg/Design/Pixels": 743,
	"./icons/svg/Design/Pixels.svg": 743,
	"./icons/svg/Design/Polygon": 744,
	"./icons/svg/Design/Polygon.svg": 744,
	"./icons/svg/Design/Position": 745,
	"./icons/svg/Design/Position.svg": 745,
	"./icons/svg/Design/Rectangle": 746,
	"./icons/svg/Design/Rectangle.svg": 746,
	"./icons/svg/Design/Saturation": 747,
	"./icons/svg/Design/Saturation.svg": 747,
	"./icons/svg/Design/Select": 748,
	"./icons/svg/Design/Select.svg": 748,
	"./icons/svg/Design/Sketch": 749,
	"./icons/svg/Design/Sketch.svg": 749,
	"./icons/svg/Design/Stamp": 750,
	"./icons/svg/Design/Stamp.svg": 750,
	"./icons/svg/Design/Substract": 751,
	"./icons/svg/Design/Substract.svg": 751,
	"./icons/svg/Design/Target": 752,
	"./icons/svg/Design/Target.svg": 752,
	"./icons/svg/Design/Triangle": 753,
	"./icons/svg/Design/Triangle.svg": 753,
	"./icons/svg/Design/Union": 754,
	"./icons/svg/Design/Union.svg": 754,
	"./icons/svg/Design/Vertical": 755,
	"./icons/svg/Design/Vertical.svg": 755,
	"./icons/svg/Design/ZoomMinus": 756,
	"./icons/svg/Design/ZoomMinus.svg": 756,
	"./icons/svg/Design/ZoomPlus": 757,
	"./icons/svg/Design/ZoomPlus.svg": 757,
	"./icons/svg/Devices/Airpods": 758,
	"./icons/svg/Devices/Airpods.svg": 758,
	"./icons/svg/Devices/Android": 759,
	"./icons/svg/Devices/Android.svg": 759,
	"./icons/svg/Devices/Apple-Watch": 760,
	"./icons/svg/Devices/Apple-Watch.svg": 760,
	"./icons/svg/Devices/Battery-charging": 761,
	"./icons/svg/Devices/Battery-charging.svg": 761,
	"./icons/svg/Devices/Battery-empty": 762,
	"./icons/svg/Devices/Battery-empty.svg": 762,
	"./icons/svg/Devices/Battery-full": 763,
	"./icons/svg/Devices/Battery-full.svg": 763,
	"./icons/svg/Devices/Battery-half": 764,
	"./icons/svg/Devices/Battery-half.svg": 764,
	"./icons/svg/Devices/Bluetooth": 765,
	"./icons/svg/Devices/Bluetooth.svg": 765,
	"./icons/svg/Devices/CPU1": 766,
	"./icons/svg/Devices/CPU1.svg": 766,
	"./icons/svg/Devices/CPU2": 767,
	"./icons/svg/Devices/CPU2.svg": 767,
	"./icons/svg/Devices/Camera": 768,
	"./icons/svg/Devices/Camera.svg": 768,
	"./icons/svg/Devices/Cardboard-vr": 769,
	"./icons/svg/Devices/Cardboard-vr.svg": 769,
	"./icons/svg/Devices/Cassete": 770,
	"./icons/svg/Devices/Cassete.svg": 770,
	"./icons/svg/Devices/Diagnostics": 771,
	"./icons/svg/Devices/Diagnostics.svg": 771,
	"./icons/svg/Devices/Display1": 772,
	"./icons/svg/Devices/Display1.svg": 772,
	"./icons/svg/Devices/Display2": 773,
	"./icons/svg/Devices/Display2.svg": 773,
	"./icons/svg/Devices/Display3": 774,
	"./icons/svg/Devices/Display3.svg": 774,
	"./icons/svg/Devices/Gameboy": 775,
	"./icons/svg/Devices/Gameboy.svg": 775,
	"./icons/svg/Devices/Gamepad1": 776,
	"./icons/svg/Devices/Gamepad1.svg": 776,
	"./icons/svg/Devices/Gamepad2": 777,
	"./icons/svg/Devices/Gamepad2.svg": 777,
	"./icons/svg/Devices/Generator": 778,
	"./icons/svg/Devices/Generator.svg": 778,
	"./icons/svg/Devices/Hard-drive": 779,
	"./icons/svg/Devices/Hard-drive.svg": 779,
	"./icons/svg/Devices/Headphones": 780,
	"./icons/svg/Devices/Headphones.svg": 780,
	"./icons/svg/Devices/Homepod": 781,
	"./icons/svg/Devices/Homepod.svg": 781,
	"./icons/svg/Devices/Keyboard": 782,
	"./icons/svg/Devices/Keyboard.svg": 782,
	"./icons/svg/Devices/LTE1": 783,
	"./icons/svg/Devices/LTE1.svg": 783,
	"./icons/svg/Devices/LTE2": 784,
	"./icons/svg/Devices/LTE2.svg": 784,
	"./icons/svg/Devices/Laptop": 785,
	"./icons/svg/Devices/Laptop-macbook": 786,
	"./icons/svg/Devices/Laptop-macbook.svg": 786,
	"./icons/svg/Devices/Laptop.svg": 785,
	"./icons/svg/Devices/Mic": 787,
	"./icons/svg/Devices/Mic.svg": 787,
	"./icons/svg/Devices/Midi": 788,
	"./icons/svg/Devices/Midi.svg": 788,
	"./icons/svg/Devices/Mouse": 789,
	"./icons/svg/Devices/Mouse.svg": 789,
	"./icons/svg/Devices/Phone": 790,
	"./icons/svg/Devices/Phone.svg": 790,
	"./icons/svg/Devices/Printer": 791,
	"./icons/svg/Devices/Printer.svg": 791,
	"./icons/svg/Devices/Radio": 792,
	"./icons/svg/Devices/Radio.svg": 792,
	"./icons/svg/Devices/Router1": 793,
	"./icons/svg/Devices/Router1.svg": 793,
	"./icons/svg/Devices/Router2": 794,
	"./icons/svg/Devices/Router2.svg": 794,
	"./icons/svg/Devices/SD-card": 795,
	"./icons/svg/Devices/SD-card.svg": 795,
	"./icons/svg/Devices/Server": 796,
	"./icons/svg/Devices/Server.svg": 796,
	"./icons/svg/Devices/Speaker": 797,
	"./icons/svg/Devices/Speaker.svg": 797,
	"./icons/svg/Devices/TV1": 798,
	"./icons/svg/Devices/TV1.svg": 798,
	"./icons/svg/Devices/TV2": 799,
	"./icons/svg/Devices/TV2.svg": 799,
	"./icons/svg/Devices/Tablet": 800,
	"./icons/svg/Devices/Tablet.svg": 800,
	"./icons/svg/Devices/USB": 801,
	"./icons/svg/Devices/USB.svg": 801,
	"./icons/svg/Devices/Usb-storage": 802,
	"./icons/svg/Devices/Usb-storage.svg": 802,
	"./icons/svg/Devices/Video-camera": 803,
	"./icons/svg/Devices/Video-camera.svg": 803,
	"./icons/svg/Devices/Watch1": 804,
	"./icons/svg/Devices/Watch1.svg": 804,
	"./icons/svg/Devices/Watch2": 805,
	"./icons/svg/Devices/Watch2.svg": 805,
	"./icons/svg/Devices/Wi-fi": 806,
	"./icons/svg/Devices/Wi-fi.svg": 806,
	"./icons/svg/Devices/iMac": 807,
	"./icons/svg/Devices/iMac.svg": 807,
	"./icons/svg/Devices/iPhone-X": 808,
	"./icons/svg/Devices/iPhone-X.svg": 808,
	"./icons/svg/Devices/iPhone-back": 809,
	"./icons/svg/Devices/iPhone-back.svg": 809,
	"./icons/svg/Devices/iPhone-x-back": 810,
	"./icons/svg/Devices/iPhone-x-back.svg": 810,
	"./icons/svg/Electric/Air-conditioning": 811,
	"./icons/svg/Electric/Air-conditioning.svg": 811,
	"./icons/svg/Electric/Blender": 812,
	"./icons/svg/Electric/Blender.svg": 812,
	"./icons/svg/Electric/Fan": 813,
	"./icons/svg/Electric/Fan.svg": 813,
	"./icons/svg/Electric/Fridge": 814,
	"./icons/svg/Electric/Fridge.svg": 814,
	"./icons/svg/Electric/Gas-stove": 815,
	"./icons/svg/Electric/Gas-stove.svg": 815,
	"./icons/svg/Electric/Highvoltage": 816,
	"./icons/svg/Electric/Highvoltage.svg": 816,
	"./icons/svg/Electric/Iron": 817,
	"./icons/svg/Electric/Iron.svg": 817,
	"./icons/svg/Electric/Kettle": 818,
	"./icons/svg/Electric/Kettle.svg": 818,
	"./icons/svg/Electric/Mixer": 819,
	"./icons/svg/Electric/Mixer.svg": 819,
	"./icons/svg/Electric/Outlet": 820,
	"./icons/svg/Electric/Outlet.svg": 820,
	"./icons/svg/Electric/Range-hood": 821,
	"./icons/svg/Electric/Range-hood.svg": 821,
	"./icons/svg/Electric/Shutdown": 822,
	"./icons/svg/Electric/Shutdown.svg": 822,
	"./icons/svg/Electric/Socket-eu": 823,
	"./icons/svg/Electric/Socket-eu.svg": 823,
	"./icons/svg/Electric/Socket-us": 824,
	"./icons/svg/Electric/Socket-us.svg": 824,
	"./icons/svg/Electric/Washer": 825,
	"./icons/svg/Electric/Washer.svg": 825,
	"./icons/svg/Electric/air-dryer": 826,
	"./icons/svg/Electric/air-dryer.svg": 826,
	"./icons/svg/Files/Cloud-download": 827,
	"./icons/svg/Files/Cloud-download.svg": 827,
	"./icons/svg/Files/Cloud-upload": 828,
	"./icons/svg/Files/Cloud-upload.svg": 828,
	"./icons/svg/Files/Compilation": 829,
	"./icons/svg/Files/Compilation.svg": 829,
	"./icons/svg/Files/Compiled-file": 830,
	"./icons/svg/Files/Compiled-file.svg": 830,
	"./icons/svg/Files/Deleted-file": 831,
	"./icons/svg/Files/Deleted-file.svg": 831,
	"./icons/svg/Files/Deleted-folder": 832,
	"./icons/svg/Files/Deleted-folder.svg": 832,
	"./icons/svg/Files/Download": 833,
	"./icons/svg/Files/Download.svg": 833,
	"./icons/svg/Files/DownloadedFile": 834,
	"./icons/svg/Files/DownloadedFile.svg": 834,
	"./icons/svg/Files/Downloads-folder": 835,
	"./icons/svg/Files/Downloads-folder.svg": 835,
	"./icons/svg/Files/Export": 836,
	"./icons/svg/Files/Export.svg": 836,
	"./icons/svg/Files/File": 837,
	"./icons/svg/Files/File-cloud": 838,
	"./icons/svg/Files/File-cloud.svg": 838,
	"./icons/svg/Files/File-done": 839,
	"./icons/svg/Files/File-done.svg": 839,
	"./icons/svg/Files/File-minus": 840,
	"./icons/svg/Files/File-minus.svg": 840,
	"./icons/svg/Files/File-plus": 841,
	"./icons/svg/Files/File-plus.svg": 841,
	"./icons/svg/Files/File.svg": 837,
	"./icons/svg/Files/Folder": 842,
	"./icons/svg/Files/Folder-check": 843,
	"./icons/svg/Files/Folder-check.svg": 843,
	"./icons/svg/Files/Folder-cloud": 844,
	"./icons/svg/Files/Folder-cloud.svg": 844,
	"./icons/svg/Files/Folder-error": 845,
	"./icons/svg/Files/Folder-error.svg": 845,
	"./icons/svg/Files/Folder-heart": 846,
	"./icons/svg/Files/Folder-heart.svg": 846,
	"./icons/svg/Files/Folder-minus": 847,
	"./icons/svg/Files/Folder-minus.svg": 847,
	"./icons/svg/Files/Folder-plus": 848,
	"./icons/svg/Files/Folder-plus.svg": 848,
	"./icons/svg/Files/Folder-solid": 849,
	"./icons/svg/Files/Folder-solid.svg": 849,
	"./icons/svg/Files/Folder-star": 850,
	"./icons/svg/Files/Folder-star.svg": 850,
	"./icons/svg/Files/Folder-thunder": 851,
	"./icons/svg/Files/Folder-thunder.svg": 851,
	"./icons/svg/Files/Folder.svg": 842,
	"./icons/svg/Files/Group-folders": 852,
	"./icons/svg/Files/Group-folders.svg": 852,
	"./icons/svg/Files/Import": 853,
	"./icons/svg/Files/Import.svg": 853,
	"./icons/svg/Files/Locked-folder": 854,
	"./icons/svg/Files/Locked-folder.svg": 854,
	"./icons/svg/Files/Media": 855,
	"./icons/svg/Files/Media-folder": 856,
	"./icons/svg/Files/Media-folder.svg": 856,
	"./icons/svg/Files/Media.svg": 855,
	"./icons/svg/Files/Music": 857,
	"./icons/svg/Files/Music.svg": 857,
	"./icons/svg/Files/Pictures1": 858,
	"./icons/svg/Files/Pictures1.svg": 858,
	"./icons/svg/Files/Pictures2": 859,
	"./icons/svg/Files/Pictures2.svg": 859,
	"./icons/svg/Files/Protected-file": 860,
	"./icons/svg/Files/Protected-file.svg": 860,
	"./icons/svg/Files/Selected-file": 861,
	"./icons/svg/Files/Selected-file.svg": 861,
	"./icons/svg/Files/Share": 862,
	"./icons/svg/Files/Share.svg": 862,
	"./icons/svg/Files/Upload": 863,
	"./icons/svg/Files/Upload-folder": 864,
	"./icons/svg/Files/Upload-folder.svg": 864,
	"./icons/svg/Files/Upload.svg": 863,
	"./icons/svg/Files/Uploaded-file": 865,
	"./icons/svg/Files/Uploaded-file.svg": 865,
	"./icons/svg/Files/User-folder": 866,
	"./icons/svg/Files/User-folder.svg": 866,
	"./icons/svg/Food/Beer": 867,
	"./icons/svg/Food/Beer.svg": 867,
	"./icons/svg/Food/Bottle1": 868,
	"./icons/svg/Food/Bottle1.svg": 868,
	"./icons/svg/Food/Bottle2": 869,
	"./icons/svg/Food/Bottle2.svg": 869,
	"./icons/svg/Food/Bread": 870,
	"./icons/svg/Food/Bread.svg": 870,
	"./icons/svg/Food/Bucket": 871,
	"./icons/svg/Food/Bucket.svg": 871,
	"./icons/svg/Food/Burger": 872,
	"./icons/svg/Food/Burger.svg": 872,
	"./icons/svg/Food/Cake": 873,
	"./icons/svg/Food/Cake.svg": 873,
	"./icons/svg/Food/Carrot": 874,
	"./icons/svg/Food/Carrot.svg": 874,
	"./icons/svg/Food/Cheese": 875,
	"./icons/svg/Food/Cheese.svg": 875,
	"./icons/svg/Food/Chicken": 876,
	"./icons/svg/Food/Chicken.svg": 876,
	"./icons/svg/Food/Coffee1": 877,
	"./icons/svg/Food/Coffee1.svg": 877,
	"./icons/svg/Food/Coffee2": 878,
	"./icons/svg/Food/Coffee2.svg": 878,
	"./icons/svg/Food/Cookie": 879,
	"./icons/svg/Food/Cookie.svg": 879,
	"./icons/svg/Food/Dinner": 880,
	"./icons/svg/Food/Dinner.svg": 880,
	"./icons/svg/Food/Fish": 881,
	"./icons/svg/Food/Fish.svg": 881,
	"./icons/svg/Food/French Bread": 882,
	"./icons/svg/Food/French Bread.svg": 882,
	"./icons/svg/Food/Glass-martini": 883,
	"./icons/svg/Food/Glass-martini.svg": 883,
	"./icons/svg/Food/Ice-cream1": 884,
	"./icons/svg/Food/Ice-cream1.svg": 884,
	"./icons/svg/Food/Ice-cream2": 885,
	"./icons/svg/Food/Ice-cream2.svg": 885,
	"./icons/svg/Food/Miso-soup": 886,
	"./icons/svg/Food/Miso-soup.svg": 886,
	"./icons/svg/Food/Orange": 887,
	"./icons/svg/Food/Orange.svg": 887,
	"./icons/svg/Food/Pizza": 888,
	"./icons/svg/Food/Pizza.svg": 888,
	"./icons/svg/Food/Sushi": 889,
	"./icons/svg/Food/Sushi.svg": 889,
	"./icons/svg/Food/Two-bottles": 890,
	"./icons/svg/Food/Two-bottles.svg": 890,
	"./icons/svg/Food/Wine": 891,
	"./icons/svg/Food/Wine.svg": 891,
	"./icons/svg/General/Attachment1": 892,
	"./icons/svg/General/Attachment1.svg": 892,
	"./icons/svg/General/Attachment2": 893,
	"./icons/svg/General/Attachment2.svg": 893,
	"./icons/svg/General/Binocular": 894,
	"./icons/svg/General/Binocular.svg": 894,
	"./icons/svg/General/Bookmark": 895,
	"./icons/svg/General/Bookmark.svg": 895,
	"./icons/svg/General/Clip": 896,
	"./icons/svg/General/Clip.svg": 896,
	"./icons/svg/General/Clipboard": 897,
	"./icons/svg/General/Clipboard.svg": 897,
	"./icons/svg/General/Cursor": 898,
	"./icons/svg/General/Cursor.svg": 898,
	"./icons/svg/General/Dislike": 899,
	"./icons/svg/General/Dislike.svg": 899,
	"./icons/svg/General/Duplicate": 900,
	"./icons/svg/General/Duplicate.svg": 900,
	"./icons/svg/General/Edit": 901,
	"./icons/svg/General/Edit.svg": 901,
	"./icons/svg/General/Expand-arrows": 902,
	"./icons/svg/General/Expand-arrows.svg": 902,
	"./icons/svg/General/Fire": 903,
	"./icons/svg/General/Fire.svg": 903,
	"./icons/svg/General/Folder": 904,
	"./icons/svg/General/Folder.svg": 904,
	"./icons/svg/General/Half-heart": 905,
	"./icons/svg/General/Half-heart.svg": 905,
	"./icons/svg/General/Half-star": 906,
	"./icons/svg/General/Half-star.svg": 906,
	"./icons/svg/General/Heart": 907,
	"./icons/svg/General/Heart.svg": 907,
	"./icons/svg/General/Hidden": 908,
	"./icons/svg/General/Hidden.svg": 908,
	"./icons/svg/General/Like": 909,
	"./icons/svg/General/Like.svg": 909,
	"./icons/svg/General/Lock": 910,
	"./icons/svg/General/Lock.svg": 910,
	"./icons/svg/General/Notification2": 911,
	"./icons/svg/General/Notification2.svg": 911,
	"./icons/svg/General/Notifications1": 912,
	"./icons/svg/General/Notifications1.svg": 912,
	"./icons/svg/General/Other1": 913,
	"./icons/svg/General/Other1.svg": 913,
	"./icons/svg/General/Other2": 914,
	"./icons/svg/General/Other2.svg": 914,
	"./icons/svg/General/Sad": 915,
	"./icons/svg/General/Sad.svg": 915,
	"./icons/svg/General/Save": 916,
	"./icons/svg/General/Save.svg": 916,
	"./icons/svg/General/Scale": 917,
	"./icons/svg/General/Scale.svg": 917,
	"./icons/svg/General/Scissors": 918,
	"./icons/svg/General/Scissors.svg": 918,
	"./icons/svg/General/Search": 919,
	"./icons/svg/General/Search.svg": 919,
	"./icons/svg/General/Settings#3": 920,
	"./icons/svg/General/Settings#3.svg": 920,
	"./icons/svg/General/Settings-1": 921,
	"./icons/svg/General/Settings-1.svg": 921,
	"./icons/svg/General/Settings-2": 922,
	"./icons/svg/General/Settings-2.svg": 922,
	"./icons/svg/General/Shield-check": 923,
	"./icons/svg/General/Shield-check.svg": 923,
	"./icons/svg/General/Shield-disabled": 924,
	"./icons/svg/General/Shield-disabled.svg": 924,
	"./icons/svg/General/Shield-protected": 925,
	"./icons/svg/General/Shield-protected.svg": 925,
	"./icons/svg/General/Size": 926,
	"./icons/svg/General/Size.svg": 926,
	"./icons/svg/General/Smile": 927,
	"./icons/svg/General/Smile.svg": 927,
	"./icons/svg/General/Star": 928,
	"./icons/svg/General/Star.svg": 928,
	"./icons/svg/General/Thunder": 929,
	"./icons/svg/General/Thunder-move": 930,
	"./icons/svg/General/Thunder-move.svg": 930,
	"./icons/svg/General/Thunder.svg": 929,
	"./icons/svg/General/Trash": 931,
	"./icons/svg/General/Trash.svg": 931,
	"./icons/svg/General/Unlock": 932,
	"./icons/svg/General/Unlock.svg": 932,
	"./icons/svg/General/Update": 933,
	"./icons/svg/General/Update.svg": 933,
	"./icons/svg/General/User": 934,
	"./icons/svg/General/User.svg": 934,
	"./icons/svg/General/Visible": 935,
	"./icons/svg/General/Visible.svg": 935,
	"./icons/svg/Home/Air-ballon": 936,
	"./icons/svg/Home/Air-ballon.svg": 936,
	"./icons/svg/Home/Alarm-clock": 937,
	"./icons/svg/Home/Alarm-clock.svg": 937,
	"./icons/svg/Home/Armchair": 938,
	"./icons/svg/Home/Armchair.svg": 938,
	"./icons/svg/Home/Bag-chair": 939,
	"./icons/svg/Home/Bag-chair.svg": 939,
	"./icons/svg/Home/Bath": 940,
	"./icons/svg/Home/Bath.svg": 940,
	"./icons/svg/Home/Bed": 941,
	"./icons/svg/Home/Bed.svg": 941,
	"./icons/svg/Home/Book": 942,
	"./icons/svg/Home/Book-open": 943,
	"./icons/svg/Home/Book-open.svg": 943,
	"./icons/svg/Home/Book.svg": 942,
	"./icons/svg/Home/Box": 944,
	"./icons/svg/Home/Box.svg": 944,
	"./icons/svg/Home/Broom": 945,
	"./icons/svg/Home/Broom.svg": 945,
	"./icons/svg/Home/Building": 946,
	"./icons/svg/Home/Building.svg": 946,
	"./icons/svg/Home/Bulb1": 947,
	"./icons/svg/Home/Bulb1.svg": 947,
	"./icons/svg/Home/Bulb2": 948,
	"./icons/svg/Home/Bulb2.svg": 948,
	"./icons/svg/Home/Chair1": 949,
	"./icons/svg/Home/Chair1.svg": 949,
	"./icons/svg/Home/Chair2": 950,
	"./icons/svg/Home/Chair2.svg": 950,
	"./icons/svg/Home/Clock": 951,
	"./icons/svg/Home/Clock.svg": 951,
	"./icons/svg/Home/Commode1": 952,
	"./icons/svg/Home/Commode1.svg": 952,
	"./icons/svg/Home/Commode2": 953,
	"./icons/svg/Home/Commode2.svg": 953,
	"./icons/svg/Home/Couch": 954,
	"./icons/svg/Home/Couch.svg": 954,
	"./icons/svg/Home/Cupboard": 955,
	"./icons/svg/Home/Cupboard.svg": 955,
	"./icons/svg/Home/Curtains": 956,
	"./icons/svg/Home/Curtains.svg": 956,
	"./icons/svg/Home/Deer": 957,
	"./icons/svg/Home/Deer.svg": 957,
	"./icons/svg/Home/Door-open": 958,
	"./icons/svg/Home/Door-open.svg": 958,
	"./icons/svg/Home/Earth": 959,
	"./icons/svg/Home/Earth.svg": 959,
	"./icons/svg/Home/Fireplace": 960,
	"./icons/svg/Home/Fireplace.svg": 960,
	"./icons/svg/Home/Flashlight": 961,
	"./icons/svg/Home/Flashlight.svg": 961,
	"./icons/svg/Home/Flower1": 962,
	"./icons/svg/Home/Flower1.svg": 962,
	"./icons/svg/Home/Flower2": 963,
	"./icons/svg/Home/Flower2.svg": 963,
	"./icons/svg/Home/Flower3": 964,
	"./icons/svg/Home/Flower3.svg": 964,
	"./icons/svg/Home/Globe": 965,
	"./icons/svg/Home/Globe.svg": 965,
	"./icons/svg/Home/Home": 966,
	"./icons/svg/Home/Home-heart": 967,
	"./icons/svg/Home/Home-heart.svg": 967,
	"./icons/svg/Home/Home.svg": 966,
	"./icons/svg/Home/Key": 968,
	"./icons/svg/Home/Key.svg": 968,
	"./icons/svg/Home/Ladder": 969,
	"./icons/svg/Home/Ladder.svg": 969,
	"./icons/svg/Home/Lamp1": 970,
	"./icons/svg/Home/Lamp1.svg": 970,
	"./icons/svg/Home/Lamp2": 971,
	"./icons/svg/Home/Lamp2.svg": 971,
	"./icons/svg/Home/Library": 972,
	"./icons/svg/Home/Library.svg": 972,
	"./icons/svg/Home/Mailbox": 973,
	"./icons/svg/Home/Mailbox.svg": 973,
	"./icons/svg/Home/Mirror": 974,
	"./icons/svg/Home/Mirror.svg": 974,
	"./icons/svg/Home/Picture": 975,
	"./icons/svg/Home/Picture.svg": 975,
	"./icons/svg/Home/Ruller": 976,
	"./icons/svg/Home/Ruller.svg": 976,
	"./icons/svg/Home/Stairs": 977,
	"./icons/svg/Home/Stairs.svg": 977,
	"./icons/svg/Home/Timer": 978,
	"./icons/svg/Home/Timer.svg": 978,
	"./icons/svg/Home/Toilet": 979,
	"./icons/svg/Home/Toilet.svg": 979,
	"./icons/svg/Home/Towel": 980,
	"./icons/svg/Home/Towel.svg": 980,
	"./icons/svg/Home/Trash": 981,
	"./icons/svg/Home/Trash.svg": 981,
	"./icons/svg/Home/Water-mixer": 982,
	"./icons/svg/Home/Water-mixer.svg": 982,
	"./icons/svg/Home/Weight1": 983,
	"./icons/svg/Home/Weight1.svg": 983,
	"./icons/svg/Home/Weight2": 984,
	"./icons/svg/Home/Weight2.svg": 984,
	"./icons/svg/Home/Wood-horse": 985,
	"./icons/svg/Home/Wood-horse.svg": 985,
	"./icons/svg/Home/Wood1": 986,
	"./icons/svg/Home/Wood1.svg": 986,
	"./icons/svg/Home/Wood2": 987,
	"./icons/svg/Home/Wood2.svg": 987,
	"./icons/svg/Layout/Layout-3d": 988,
	"./icons/svg/Layout/Layout-3d.svg": 988,
	"./icons/svg/Layout/Layout-4-blocks": 989,
	"./icons/svg/Layout/Layout-4-blocks.svg": 989,
	"./icons/svg/Layout/Layout-arrange": 990,
	"./icons/svg/Layout/Layout-arrange.svg": 990,
	"./icons/svg/Layout/Layout-grid": 991,
	"./icons/svg/Layout/Layout-grid.svg": 991,
	"./icons/svg/Layout/Layout-horizontal": 992,
	"./icons/svg/Layout/Layout-horizontal.svg": 992,
	"./icons/svg/Layout/Layout-left-panel-1": 993,
	"./icons/svg/Layout/Layout-left-panel-1.svg": 993,
	"./icons/svg/Layout/Layout-left-panel-2": 994,
	"./icons/svg/Layout/Layout-left-panel-2.svg": 994,
	"./icons/svg/Layout/Layout-right-panel-1": 995,
	"./icons/svg/Layout/Layout-right-panel-1.svg": 995,
	"./icons/svg/Layout/Layout-right-panel-2": 996,
	"./icons/svg/Layout/Layout-right-panel-2.svg": 996,
	"./icons/svg/Layout/Layout-top-panel-1": 997,
	"./icons/svg/Layout/Layout-top-panel-1.svg": 997,
	"./icons/svg/Layout/Layout-top-panel-2": 998,
	"./icons/svg/Layout/Layout-top-panel-2.svg": 998,
	"./icons/svg/Layout/Layout-top-panel-3": 999,
	"./icons/svg/Layout/Layout-top-panel-3.svg": 999,
	"./icons/svg/Layout/Layout-top-panel-4": 1000,
	"./icons/svg/Layout/Layout-top-panel-4.svg": 1000,
	"./icons/svg/Layout/Layout-top-panel-5": 1001,
	"./icons/svg/Layout/Layout-top-panel-5.svg": 1001,
	"./icons/svg/Layout/Layout-top-panel-6": 1002,
	"./icons/svg/Layout/Layout-top-panel-6.svg": 1002,
	"./icons/svg/Layout/Layout-vertical": 1003,
	"./icons/svg/Layout/Layout-vertical.svg": 1003,
	"./icons/svg/Map/Compass": 1004,
	"./icons/svg/Map/Compass.svg": 1004,
	"./icons/svg/Map/Direction1": 1005,
	"./icons/svg/Map/Direction1.svg": 1005,
	"./icons/svg/Map/Direction2": 1006,
	"./icons/svg/Map/Direction2.svg": 1006,
	"./icons/svg/Map/Location-arrow": 1007,
	"./icons/svg/Map/Location-arrow.svg": 1007,
	"./icons/svg/Map/Marker1": 1008,
	"./icons/svg/Map/Marker1.svg": 1008,
	"./icons/svg/Map/Marker2": 1009,
	"./icons/svg/Map/Marker2.svg": 1009,
	"./icons/svg/Map/Position": 1010,
	"./icons/svg/Map/Position.svg": 1010,
	"./icons/svg/Media/Add-music": 1011,
	"./icons/svg/Media/Add-music.svg": 1011,
	"./icons/svg/Media/Airplay": 1012,
	"./icons/svg/Media/Airplay-video": 1013,
	"./icons/svg/Media/Airplay-video.svg": 1013,
	"./icons/svg/Media/Airplay.svg": 1012,
	"./icons/svg/Media/Back": 1014,
	"./icons/svg/Media/Back.svg": 1014,
	"./icons/svg/Media/Backward": 1015,
	"./icons/svg/Media/Backward.svg": 1015,
	"./icons/svg/Media/CD": 1016,
	"./icons/svg/Media/CD.svg": 1016,
	"./icons/svg/Media/DVD": 1017,
	"./icons/svg/Media/DVD.svg": 1017,
	"./icons/svg/Media/Eject": 1018,
	"./icons/svg/Media/Eject.svg": 1018,
	"./icons/svg/Media/Equalizer": 1019,
	"./icons/svg/Media/Equalizer.svg": 1019,
	"./icons/svg/Media/Forward": 1020,
	"./icons/svg/Media/Forward.svg": 1020,
	"./icons/svg/Media/Media-library1": 1021,
	"./icons/svg/Media/Media-library1.svg": 1021,
	"./icons/svg/Media/Media-library2": 1022,
	"./icons/svg/Media/Media-library2.svg": 1022,
	"./icons/svg/Media/Media-library3": 1023,
	"./icons/svg/Media/Media-library3.svg": 1023,
	"./icons/svg/Media/Movie-Lane2": 1024,
	"./icons/svg/Media/Movie-Lane2.svg": 1024,
	"./icons/svg/Media/Movie-lane1": 1025,
	"./icons/svg/Media/Movie-lane1.svg": 1025,
	"./icons/svg/Media/Music": 1026,
	"./icons/svg/Media/Music-cloud": 1027,
	"./icons/svg/Media/Music-cloud.svg": 1027,
	"./icons/svg/Media/Music-note": 1028,
	"./icons/svg/Media/Music-note.svg": 1028,
	"./icons/svg/Media/Music.svg": 1026,
	"./icons/svg/Media/Mute": 1029,
	"./icons/svg/Media/Mute.svg": 1029,
	"./icons/svg/Media/Next": 1030,
	"./icons/svg/Media/Next.svg": 1030,
	"./icons/svg/Media/Pause": 1031,
	"./icons/svg/Media/Pause.svg": 1031,
	"./icons/svg/Media/Play": 1032,
	"./icons/svg/Media/Play.svg": 1032,
	"./icons/svg/Media/Playlist1": 1033,
	"./icons/svg/Media/Playlist1.svg": 1033,
	"./icons/svg/Media/Playlist2": 1034,
	"./icons/svg/Media/Playlist2.svg": 1034,
	"./icons/svg/Media/Rec": 1035,
	"./icons/svg/Media/Rec.svg": 1035,
	"./icons/svg/Media/Repeat": 1036,
	"./icons/svg/Media/Repeat-one": 1037,
	"./icons/svg/Media/Repeat-one.svg": 1037,
	"./icons/svg/Media/Repeat.svg": 1036,
	"./icons/svg/Media/Shuffle": 1038,
	"./icons/svg/Media/Shuffle.svg": 1038,
	"./icons/svg/Media/Volume-down": 1039,
	"./icons/svg/Media/Volume-down.svg": 1039,
	"./icons/svg/Media/Volume-full": 1040,
	"./icons/svg/Media/Volume-full.svg": 1040,
	"./icons/svg/Media/Volume-half": 1041,
	"./icons/svg/Media/Volume-half.svg": 1041,
	"./icons/svg/Media/Volume-up": 1042,
	"./icons/svg/Media/Volume-up.svg": 1042,
	"./icons/svg/Media/Vynil": 1043,
	"./icons/svg/Media/Vynil.svg": 1043,
	"./icons/svg/Media/Youtube": 1044,
	"./icons/svg/Media/Youtube.svg": 1044,
	"./icons/svg/Navigation/Angle-double-down": 1045,
	"./icons/svg/Navigation/Angle-double-down.svg": 1045,
	"./icons/svg/Navigation/Angle-double-left": 1046,
	"./icons/svg/Navigation/Angle-double-left.svg": 1046,
	"./icons/svg/Navigation/Angle-double-right": 1047,
	"./icons/svg/Navigation/Angle-double-right.svg": 1047,
	"./icons/svg/Navigation/Angle-double-up": 1048,
	"./icons/svg/Navigation/Angle-double-up.svg": 1048,
	"./icons/svg/Navigation/Angle-down": 1049,
	"./icons/svg/Navigation/Angle-down.svg": 1049,
	"./icons/svg/Navigation/Angle-left": 1050,
	"./icons/svg/Navigation/Angle-left.svg": 1050,
	"./icons/svg/Navigation/Angle-right": 1051,
	"./icons/svg/Navigation/Angle-right.svg": 1051,
	"./icons/svg/Navigation/Arrow-down": 1052,
	"./icons/svg/Navigation/Arrow-down.svg": 1052,
	"./icons/svg/Navigation/Arrow-from-bottom": 1053,
	"./icons/svg/Navigation/Arrow-from-bottom.svg": 1053,
	"./icons/svg/Navigation/Arrow-from-left": 1054,
	"./icons/svg/Navigation/Arrow-from-left.svg": 1054,
	"./icons/svg/Navigation/Arrow-from-right": 1055,
	"./icons/svg/Navigation/Arrow-from-right.svg": 1055,
	"./icons/svg/Navigation/Arrow-from-top": 1056,
	"./icons/svg/Navigation/Arrow-from-top.svg": 1056,
	"./icons/svg/Navigation/Arrow-left": 1057,
	"./icons/svg/Navigation/Arrow-left.svg": 1057,
	"./icons/svg/Navigation/Arrow-right": 1058,
	"./icons/svg/Navigation/Arrow-right.svg": 1058,
	"./icons/svg/Navigation/Arrow-to-bottom": 1059,
	"./icons/svg/Navigation/Arrow-to-bottom.svg": 1059,
	"./icons/svg/Navigation/Arrow-to-left": 1060,
	"./icons/svg/Navigation/Arrow-to-left.svg": 1060,
	"./icons/svg/Navigation/Arrow-to-right": 1061,
	"./icons/svg/Navigation/Arrow-to-right.svg": 1061,
	"./icons/svg/Navigation/Arrow-to-up": 1062,
	"./icons/svg/Navigation/Arrow-to-up.svg": 1062,
	"./icons/svg/Navigation/Arrow-up": 1063,
	"./icons/svg/Navigation/Arrow-up.svg": 1063,
	"./icons/svg/Navigation/Arrows-h": 1064,
	"./icons/svg/Navigation/Arrows-h.svg": 1064,
	"./icons/svg/Navigation/Arrows-v": 1065,
	"./icons/svg/Navigation/Arrows-v.svg": 1065,
	"./icons/svg/Navigation/Check": 1066,
	"./icons/svg/Navigation/Check.svg": 1066,
	"./icons/svg/Navigation/Close": 1067,
	"./icons/svg/Navigation/Close.svg": 1067,
	"./icons/svg/Navigation/Double-check": 1068,
	"./icons/svg/Navigation/Double-check.svg": 1068,
	"./icons/svg/Navigation/Down-2": 1069,
	"./icons/svg/Navigation/Down-2.svg": 1069,
	"./icons/svg/Navigation/Down-left": 1070,
	"./icons/svg/Navigation/Down-left.svg": 1070,
	"./icons/svg/Navigation/Down-right": 1071,
	"./icons/svg/Navigation/Down-right.svg": 1071,
	"./icons/svg/Navigation/Exchange": 1072,
	"./icons/svg/Navigation/Exchange.svg": 1072,
	"./icons/svg/Navigation/Left 3": 1073,
	"./icons/svg/Navigation/Left 3.svg": 1073,
	"./icons/svg/Navigation/Left-2": 1074,
	"./icons/svg/Navigation/Left-2.svg": 1074,
	"./icons/svg/Navigation/Minus": 1075,
	"./icons/svg/Navigation/Minus.svg": 1075,
	"./icons/svg/Navigation/Plus": 1076,
	"./icons/svg/Navigation/Plus.svg": 1076,
	"./icons/svg/Navigation/Right 3": 1077,
	"./icons/svg/Navigation/Right 3.svg": 1077,
	"./icons/svg/Navigation/Right-2": 1078,
	"./icons/svg/Navigation/Right-2.svg": 1078,
	"./icons/svg/Navigation/Route": 1079,
	"./icons/svg/Navigation/Route.svg": 1079,
	"./icons/svg/Navigation/Sign-in": 1080,
	"./icons/svg/Navigation/Sign-in.svg": 1080,
	"./icons/svg/Navigation/Sign-out": 1081,
	"./icons/svg/Navigation/Sign-out.svg": 1081,
	"./icons/svg/Navigation/Stockholm-icons/Navigation/Angle-up": 1082,
	"./icons/svg/Navigation/Stockholm-icons/Navigation/Angle-up.svg": 1082,
	"./icons/svg/Navigation/Up-2": 1083,
	"./icons/svg/Navigation/Up-2.svg": 1083,
	"./icons/svg/Navigation/Up-down": 1084,
	"./icons/svg/Navigation/Up-down.svg": 1084,
	"./icons/svg/Navigation/Up-left": 1085,
	"./icons/svg/Navigation/Up-left.svg": 1085,
	"./icons/svg/Navigation/Up-right": 1086,
	"./icons/svg/Navigation/Up-right.svg": 1086,
	"./icons/svg/Navigation/Waiting": 1087,
	"./icons/svg/Navigation/Waiting.svg": 1087,
	"./icons/svg/Shopping/ATM": 1088,
	"./icons/svg/Shopping/ATM.svg": 1088,
	"./icons/svg/Shopping/Bag1": 1089,
	"./icons/svg/Shopping/Bag1.svg": 1089,
	"./icons/svg/Shopping/Bag2": 1090,
	"./icons/svg/Shopping/Bag2.svg": 1090,
	"./icons/svg/Shopping/Barcode": 1091,
	"./icons/svg/Shopping/Barcode-read": 1092,
	"./icons/svg/Shopping/Barcode-read.svg": 1092,
	"./icons/svg/Shopping/Barcode-scan": 1093,
	"./icons/svg/Shopping/Barcode-scan.svg": 1093,
	"./icons/svg/Shopping/Barcode.svg": 1091,
	"./icons/svg/Shopping/Bitcoin": 1094,
	"./icons/svg/Shopping/Bitcoin.svg": 1094,
	"./icons/svg/Shopping/Box1": 1095,
	"./icons/svg/Shopping/Box1.svg": 1095,
	"./icons/svg/Shopping/Box2": 1096,
	"./icons/svg/Shopping/Box2.svg": 1096,
	"./icons/svg/Shopping/Box3": 1097,
	"./icons/svg/Shopping/Box3.svg": 1097,
	"./icons/svg/Shopping/Calculator": 1098,
	"./icons/svg/Shopping/Calculator.svg": 1098,
	"./icons/svg/Shopping/Cart1": 1099,
	"./icons/svg/Shopping/Cart1.svg": 1099,
	"./icons/svg/Shopping/Cart2": 1100,
	"./icons/svg/Shopping/Cart2.svg": 1100,
	"./icons/svg/Shopping/Cart3": 1101,
	"./icons/svg/Shopping/Cart3.svg": 1101,
	"./icons/svg/Shopping/Chart-bar1": 1102,
	"./icons/svg/Shopping/Chart-bar1.svg": 1102,
	"./icons/svg/Shopping/Chart-bar2": 1103,
	"./icons/svg/Shopping/Chart-bar2.svg": 1103,
	"./icons/svg/Shopping/Chart-bar3": 1104,
	"./icons/svg/Shopping/Chart-bar3.svg": 1104,
	"./icons/svg/Shopping/Chart-line1": 1105,
	"./icons/svg/Shopping/Chart-line1.svg": 1105,
	"./icons/svg/Shopping/Chart-line2": 1106,
	"./icons/svg/Shopping/Chart-line2.svg": 1106,
	"./icons/svg/Shopping/Chart-pie": 1107,
	"./icons/svg/Shopping/Chart-pie.svg": 1107,
	"./icons/svg/Shopping/Credit-card": 1108,
	"./icons/svg/Shopping/Credit-card.svg": 1108,
	"./icons/svg/Shopping/Dollar": 1109,
	"./icons/svg/Shopping/Dollar.svg": 1109,
	"./icons/svg/Shopping/Euro": 1110,
	"./icons/svg/Shopping/Euro.svg": 1110,
	"./icons/svg/Shopping/Gift": 1111,
	"./icons/svg/Shopping/Gift.svg": 1111,
	"./icons/svg/Shopping/Loader": 1112,
	"./icons/svg/Shopping/Loader.svg": 1112,
	"./icons/svg/Shopping/MC": 1113,
	"./icons/svg/Shopping/MC.svg": 1113,
	"./icons/svg/Shopping/Money": 1114,
	"./icons/svg/Shopping/Money.svg": 1114,
	"./icons/svg/Shopping/Pound": 1115,
	"./icons/svg/Shopping/Pound.svg": 1115,
	"./icons/svg/Shopping/Price1": 1116,
	"./icons/svg/Shopping/Price1.svg": 1116,
	"./icons/svg/Shopping/Price2": 1117,
	"./icons/svg/Shopping/Price2.svg": 1117,
	"./icons/svg/Shopping/Rouble": 1118,
	"./icons/svg/Shopping/Rouble.svg": 1118,
	"./icons/svg/Shopping/Safe": 1119,
	"./icons/svg/Shopping/Safe.svg": 1119,
	"./icons/svg/Shopping/Sale1": 1120,
	"./icons/svg/Shopping/Sale1.svg": 1120,
	"./icons/svg/Shopping/Sale2": 1121,
	"./icons/svg/Shopping/Sale2.svg": 1121,
	"./icons/svg/Shopping/Settings": 1122,
	"./icons/svg/Shopping/Settings.svg": 1122,
	"./icons/svg/Shopping/Sort1": 1123,
	"./icons/svg/Shopping/Sort1.svg": 1123,
	"./icons/svg/Shopping/Sort2": 1124,
	"./icons/svg/Shopping/Sort2.svg": 1124,
	"./icons/svg/Shopping/Sort3": 1125,
	"./icons/svg/Shopping/Sort3.svg": 1125,
	"./icons/svg/Shopping/Ticket": 1126,
	"./icons/svg/Shopping/Ticket.svg": 1126,
	"./icons/svg/Shopping/Wallet": 1127,
	"./icons/svg/Shopping/Wallet.svg": 1127,
	"./icons/svg/Shopping/Wallet2": 1128,
	"./icons/svg/Shopping/Wallet2.svg": 1128,
	"./icons/svg/Shopping/Wallet3": 1129,
	"./icons/svg/Shopping/Wallet3.svg": 1129,
	"./icons/svg/Text/Align-auto": 1130,
	"./icons/svg/Text/Align-auto.svg": 1130,
	"./icons/svg/Text/Align-center": 1131,
	"./icons/svg/Text/Align-center.svg": 1131,
	"./icons/svg/Text/Align-justify": 1132,
	"./icons/svg/Text/Align-justify.svg": 1132,
	"./icons/svg/Text/Align-left": 1133,
	"./icons/svg/Text/Align-left.svg": 1133,
	"./icons/svg/Text/Align-right": 1134,
	"./icons/svg/Text/Align-right.svg": 1134,
	"./icons/svg/Text/Article": 1135,
	"./icons/svg/Text/Article.svg": 1135,
	"./icons/svg/Text/Bold": 1136,
	"./icons/svg/Text/Bold.svg": 1136,
	"./icons/svg/Text/Bullet-list": 1137,
	"./icons/svg/Text/Bullet-list.svg": 1137,
	"./icons/svg/Text/Code": 1138,
	"./icons/svg/Text/Code.svg": 1138,
	"./icons/svg/Text/Edit-text": 1139,
	"./icons/svg/Text/Edit-text.svg": 1139,
	"./icons/svg/Text/Filter": 1140,
	"./icons/svg/Text/Filter.svg": 1140,
	"./icons/svg/Text/Font": 1141,
	"./icons/svg/Text/Font.svg": 1141,
	"./icons/svg/Text/H1": 1142,
	"./icons/svg/Text/H1.svg": 1142,
	"./icons/svg/Text/H2": 1143,
	"./icons/svg/Text/H2.svg": 1143,
	"./icons/svg/Text/Itallic": 1144,
	"./icons/svg/Text/Itallic.svg": 1144,
	"./icons/svg/Text/Menu": 1145,
	"./icons/svg/Text/Menu.svg": 1145,
	"./icons/svg/Text/Paragraph": 1146,
	"./icons/svg/Text/Paragraph.svg": 1146,
	"./icons/svg/Text/Quote1": 1147,
	"./icons/svg/Text/Quote1.svg": 1147,
	"./icons/svg/Text/Quote2": 1148,
	"./icons/svg/Text/Quote2.svg": 1148,
	"./icons/svg/Text/Redo": 1149,
	"./icons/svg/Text/Redo.svg": 1149,
	"./icons/svg/Text/Strikethrough": 1150,
	"./icons/svg/Text/Strikethrough.svg": 1150,
	"./icons/svg/Text/Text": 1151,
	"./icons/svg/Text/Text-height": 1152,
	"./icons/svg/Text/Text-height.svg": 1152,
	"./icons/svg/Text/Text-width": 1153,
	"./icons/svg/Text/Text-width.svg": 1153,
	"./icons/svg/Text/Text.svg": 1151,
	"./icons/svg/Text/Underline": 1154,
	"./icons/svg/Text/Underline.svg": 1154,
	"./icons/svg/Text/Undo": 1155,
	"./icons/svg/Text/Undo.svg": 1155,
	"./icons/svg/Tools/Angle Grinder": 1156,
	"./icons/svg/Tools/Angle Grinder.svg": 1156,
	"./icons/svg/Tools/Axe": 1157,
	"./icons/svg/Tools/Axe.svg": 1157,
	"./icons/svg/Tools/Brush": 1158,
	"./icons/svg/Tools/Brush.svg": 1158,
	"./icons/svg/Tools/Compass": 1159,
	"./icons/svg/Tools/Compass.svg": 1159,
	"./icons/svg/Tools/Hummer": 1160,
	"./icons/svg/Tools/Hummer.svg": 1160,
	"./icons/svg/Tools/Hummer2": 1161,
	"./icons/svg/Tools/Hummer2.svg": 1161,
	"./icons/svg/Tools/Pantone": 1162,
	"./icons/svg/Tools/Pantone.svg": 1162,
	"./icons/svg/Tools/Road-Cone": 1163,
	"./icons/svg/Tools/Road-Cone.svg": 1163,
	"./icons/svg/Tools/Roller": 1164,
	"./icons/svg/Tools/Roller.svg": 1164,
	"./icons/svg/Tools/Roulette": 1165,
	"./icons/svg/Tools/Roulette.svg": 1165,
	"./icons/svg/Tools/Screwdriver": 1166,
	"./icons/svg/Tools/Screwdriver.svg": 1166,
	"./icons/svg/Tools/Shovel": 1167,
	"./icons/svg/Tools/Shovel.svg": 1167,
	"./icons/svg/Tools/Spatula": 1168,
	"./icons/svg/Tools/Spatula.svg": 1168,
	"./icons/svg/Tools/Swiss-knife": 1169,
	"./icons/svg/Tools/Swiss-knife.svg": 1169,
	"./icons/svg/Tools/Tools": 1170,
	"./icons/svg/Tools/Tools.svg": 1170,
	"./icons/svg/Weather/Celcium": 1171,
	"./icons/svg/Weather/Celcium.svg": 1171,
	"./icons/svg/Weather/Cloud-fog": 1172,
	"./icons/svg/Weather/Cloud-fog.svg": 1172,
	"./icons/svg/Weather/Cloud-sun": 1173,
	"./icons/svg/Weather/Cloud-sun.svg": 1173,
	"./icons/svg/Weather/Cloud-wind": 1174,
	"./icons/svg/Weather/Cloud-wind.svg": 1174,
	"./icons/svg/Weather/Cloud1": 1175,
	"./icons/svg/Weather/Cloud1.svg": 1175,
	"./icons/svg/Weather/Cloud2": 1176,
	"./icons/svg/Weather/Cloud2.svg": 1176,
	"./icons/svg/Weather/Cloudy": 1177,
	"./icons/svg/Weather/Cloudy-night": 1178,
	"./icons/svg/Weather/Cloudy-night.svg": 1178,
	"./icons/svg/Weather/Cloudy.svg": 1177,
	"./icons/svg/Weather/Day-rain": 1179,
	"./icons/svg/Weather/Day-rain.svg": 1179,
	"./icons/svg/Weather/Fahrenheit": 1180,
	"./icons/svg/Weather/Fahrenheit.svg": 1180,
	"./icons/svg/Weather/Fog": 1181,
	"./icons/svg/Weather/Fog.svg": 1181,
	"./icons/svg/Weather/Moon": 1182,
	"./icons/svg/Weather/Moon.svg": 1182,
	"./icons/svg/Weather/Night-fog": 1183,
	"./icons/svg/Weather/Night-fog.svg": 1183,
	"./icons/svg/Weather/Night-rain": 1184,
	"./icons/svg/Weather/Night-rain.svg": 1184,
	"./icons/svg/Weather/Rain1": 1185,
	"./icons/svg/Weather/Rain1.svg": 1185,
	"./icons/svg/Weather/Rain2": 1186,
	"./icons/svg/Weather/Rain2.svg": 1186,
	"./icons/svg/Weather/Rain5": 1187,
	"./icons/svg/Weather/Rain5.svg": 1187,
	"./icons/svg/Weather/Rainbow": 1188,
	"./icons/svg/Weather/Rainbow.svg": 1188,
	"./icons/svg/Weather/Snow": 1189,
	"./icons/svg/Weather/Snow.svg": 1189,
	"./icons/svg/Weather/Snow1": 1190,
	"./icons/svg/Weather/Snow1.svg": 1190,
	"./icons/svg/Weather/Snow2": 1191,
	"./icons/svg/Weather/Snow2.svg": 1191,
	"./icons/svg/Weather/Snow3": 1192,
	"./icons/svg/Weather/Snow3.svg": 1192,
	"./icons/svg/Weather/Storm": 1193,
	"./icons/svg/Weather/Storm.svg": 1193,
	"./icons/svg/Weather/Sun": 1194,
	"./icons/svg/Weather/Sun-fog": 1195,
	"./icons/svg/Weather/Sun-fog.svg": 1195,
	"./icons/svg/Weather/Sun.svg": 1194,
	"./icons/svg/Weather/Suset1": 1196,
	"./icons/svg/Weather/Suset1.svg": 1196,
	"./icons/svg/Weather/Suset2": 1197,
	"./icons/svg/Weather/Suset2.svg": 1197,
	"./icons/svg/Weather/Temperature-empty": 1198,
	"./icons/svg/Weather/Temperature-empty.svg": 1198,
	"./icons/svg/Weather/Temperature-full": 1199,
	"./icons/svg/Weather/Temperature-full.svg": 1199,
	"./icons/svg/Weather/Temperature-half": 1200,
	"./icons/svg/Weather/Temperature-half.svg": 1200,
	"./icons/svg/Weather/Thunder": 1201,
	"./icons/svg/Weather/Thunder-night": 1202,
	"./icons/svg/Weather/Thunder-night.svg": 1202,
	"./icons/svg/Weather/Thunder.svg": 1201,
	"./icons/svg/Weather/Umbrella": 1203,
	"./icons/svg/Weather/Umbrella.svg": 1203,
	"./icons/svg/Weather/Wind": 1204,
	"./icons/svg/Weather/Wind.svg": 1204,
	"./icons/warning": 1205,
	"./icons/warning.svg": 1205,
	"./illustrations/contact": 1206,
	"./illustrations/contact.svg": 1206,
	"./illustrations/data-points": 1207,
	"./illustrations/data-points.svg": 1207,
	"./illustrations/working": 1208,
	"./illustrations/working.svg": 1208,
	"./logos/favicon.ico": 1354,
	"./logos/logo-10": 1209,
	"./logos/logo-10-sm": 1210,
	"./logos/logo-10-sm.png": 1210,
	"./logos/logo-10.png": 1209,
	"./logos/logo-11": 1211,
	"./logos/logo-11-sm": 1212,
	"./logos/logo-11-sm.png": 1212,
	"./logos/logo-11.png": 1211,
	"./logos/logo-12": 1213,
	"./logos/logo-12.png": 1213,
	"./logos/logo-2": 1214,
	"./logos/logo-2-sm": 1215,
	"./logos/logo-2-sm.png": 1215,
	"./logos/logo-2.png": 1214,
	"./logos/logo-3": 1216,
	"./logos/logo-3.png": 1216,
	"./logos/logo-4": 1217,
	"./logos/logo-4-sm": 1218,
	"./logos/logo-4-sm.png": 1218,
	"./logos/logo-4.png": 1217,
	"./logos/logo-5": 1219,
	"./logos/logo-5-sm": 1220,
	"./logos/logo-5-sm.png": 1220,
	"./logos/logo-5.png": 1219,
	"./logos/logo-6": 1221,
	"./logos/logo-6-sm": 1222,
	"./logos/logo-6-sm.png": 1222,
	"./logos/logo-6.png": 1221,
	"./logos/logo-7": 1223,
	"./logos/logo-7-sm": 1224,
	"./logos/logo-7-sm.png": 1224,
	"./logos/logo-7.png": 1223,
	"./logos/logo-8": 1225,
	"./logos/logo-8-inverse": 1226,
	"./logos/logo-8-inverse.png": 1226,
	"./logos/logo-8-sm": 1227,
	"./logos/logo-8-sm.png": 1227,
	"./logos/logo-8.png": 1225,
	"./logos/logo-9": 1228,
	"./logos/logo-9-sm": 1229,
	"./logos/logo-9-sm.png": 1229,
	"./logos/logo-9.png": 1228,
	"./logos/logo-dark": 1230,
	"./logos/logo-dark-sm": 1231,
	"./logos/logo-dark-sm.png": 1231,
	"./logos/logo-dark.png": 1230,
	"./logos/logo-light": 1232,
	"./logos/logo-light-sm": 1233,
	"./logos/logo-light-sm.png": 1233,
	"./logos/logo-light.png": 1232,
	"./logos/logo-mini-2-md": 1234,
	"./logos/logo-mini-2-md.png": 1234,
	"./logos/logo-mini-lg": 1235,
	"./logos/logo-mini-lg.png": 1235,
	"./logos/logo-mini-md": 1236,
	"./logos/logo-mini-md.png": 1236,
	"./logos/logo-mini-sm": 1237,
	"./logos/logo-mini-sm.png": 1237,
	"./misc/bg-1": 1238,
	"./misc/bg-1.jpg": 1238,
	"./misc/bg-2": 1239,
	"./misc/bg-2.jpg": 1239,
	"./misc/owl.video.play": 1240,
	"./misc/owl.video.play.png": 1240,
	"./plugins/jstree/32px": 1241,
	"./plugins/jstree/32px.png": 1241,
	"./products/product1": 1242,
	"./products/product1.jpg": 1242,
	"./products/product10": 1243,
	"./products/product10.jpg": 1243,
	"./products/product11": 1244,
	"./products/product11.jpg": 1244,
	"./products/product12": 1245,
	"./products/product12.jpg": 1245,
	"./products/product13": 1246,
	"./products/product13.jpg": 1246,
	"./products/product14": 1247,
	"./products/product14.jpg": 1247,
	"./products/product15": 1248,
	"./products/product15.jpg": 1248,
	"./products/product16": 1249,
	"./products/product16.jpg": 1249,
	"./products/product17": 1250,
	"./products/product17.jpg": 1250,
	"./products/product18": 1251,
	"./products/product18.jpg": 1251,
	"./products/product19": 1252,
	"./products/product19.jpg": 1252,
	"./products/product2": 1253,
	"./products/product2.jpg": 1253,
	"./products/product20": 1254,
	"./products/product20.jpg": 1254,
	"./products/product21": 1255,
	"./products/product21.jpg": 1255,
	"./products/product22": 1256,
	"./products/product22.jpg": 1256,
	"./products/product23": 1257,
	"./products/product23.jpg": 1257,
	"./products/product24": 1258,
	"./products/product24.jpg": 1258,
	"./products/product25": 1259,
	"./products/product25.jpg": 1259,
	"./products/product26": 1260,
	"./products/product26.jpg": 1260,
	"./products/product27": 1261,
	"./products/product27.jpg": 1261,
	"./products/product28": 1262,
	"./products/product28.jpg": 1262,
	"./products/product3": 1263,
	"./products/product3.jpg": 1263,
	"./products/product4": 1264,
	"./products/product4.jpg": 1264,
	"./products/product5": 1265,
	"./products/product5.jpg": 1265,
	"./products/product6": 1266,
	"./products/product6.jpg": 1266,
	"./products/product7": 1267,
	"./products/product7.jpg": 1267,
	"./products/product8": 1268,
	"./products/product8.jpg": 1268,
	"./products/product9": 1269,
	"./products/product9.jpg": 1269,
	"./project-logos/1": 1270,
	"./project-logos/1.png": 1270,
	"./project-logos/2": 1271,
	"./project-logos/2.png": 1271,
	"./project-logos/3": 1272,
	"./project-logos/3.png": 1272,
	"./project-logos/4": 1273,
	"./project-logos/4.png": 1273,
	"./project-logos/5": 1274,
	"./project-logos/5.png": 1274,
	"./project-logos/6": 1275,
	"./project-logos/6.png": 1275,
	"./project-logos/7": 1276,
	"./project-logos/7.png": 1276,
	"./users/100_1": 1277,
	"./users/100_1.jpg": 1277,
	"./users/100_10": 1278,
	"./users/100_10.jpg": 1278,
	"./users/100_11": 1279,
	"./users/100_11.jpg": 1279,
	"./users/100_12": 1280,
	"./users/100_12.jpg": 1280,
	"./users/100_13": 1281,
	"./users/100_13.jpg": 1281,
	"./users/100_14": 1282,
	"./users/100_14.jpg": 1282,
	"./users/100_2": 1283,
	"./users/100_2.jpg": 1283,
	"./users/100_3": 1284,
	"./users/100_3.jpg": 1284,
	"./users/100_4": 1285,
	"./users/100_4.jpg": 1285,
	"./users/100_5": 1286,
	"./users/100_5.jpg": 1286,
	"./users/100_6": 1287,
	"./users/100_6.jpg": 1287,
	"./users/100_7": 1288,
	"./users/100_7.jpg": 1288,
	"./users/100_8": 1289,
	"./users/100_8.jpg": 1289,
	"./users/100_9": 1290,
	"./users/100_9.jpg": 1290,
	"./users/300_1": 1291,
	"./users/300_1.jpg": 1291,
	"./users/300_10": 1292,
	"./users/300_10.jpg": 1292,
	"./users/300_11": 1293,
	"./users/300_11.jpg": 1293,
	"./users/300_12": 1294,
	"./users/300_12.jpg": 1294,
	"./users/300_13": 1295,
	"./users/300_13.jpg": 1295,
	"./users/300_14": 1296,
	"./users/300_14.jpg": 1296,
	"./users/300_15": 1297,
	"./users/300_15.jpg": 1297,
	"./users/300_16": 1298,
	"./users/300_16.jpg": 1298,
	"./users/300_17": 1299,
	"./users/300_17.jpg": 1299,
	"./users/300_18": 1300,
	"./users/300_18.jpg": 1300,
	"./users/300_19": 1301,
	"./users/300_19.jpg": 1301,
	"./users/300_2": 1302,
	"./users/300_2.jpg": 1302,
	"./users/300_20": 1303,
	"./users/300_20.jpg": 1303,
	"./users/300_21": 1304,
	"./users/300_21.jpg": 1304,
	"./users/300_22": 1305,
	"./users/300_22.jpg": 1305,
	"./users/300_23": 1306,
	"./users/300_23.jpg": 1306,
	"./users/300_24": 1307,
	"./users/300_24.jpg": 1307,
	"./users/300_25": 1308,
	"./users/300_25.jpg": 1308,
	"./users/300_3": 1309,
	"./users/300_3.jpg": 1309,
	"./users/300_4": 1310,
	"./users/300_4.jpg": 1310,
	"./users/300_5": 1311,
	"./users/300_5.jpg": 1311,
	"./users/300_6": 1312,
	"./users/300_6.jpg": 1312,
	"./users/300_7": 1313,
	"./users/300_7.jpg": 1313,
	"./users/300_8": 1314,
	"./users/300_8.jpg": 1314,
	"./users/300_9": 1315,
	"./users/300_9.jpg": 1315,
	"./users/default": 1316,
	"./users/default.jpg": 1316,
	"./users/user1": 1317,
	"./users/user1.jpg": 1317,
	"./users/user2": 1318,
	"./users/user2.jpg": 1318,
	"./users/user3": 1319,
	"./users/user3.jpg": 1319,
	"./users/user4": 1320,
	"./users/user4.jpg": 1320,
	"./users/user5": 1321,
	"./users/user5.jpg": 1321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;